<template>
  <div class="frontend">
    <div
      v-show="$store.state.appConfig.showLoader || awaitingPaymentConfirmation"
      class="axios-loader"
    >
      <loader />
    </div>
    <div
      v-if="!pageNotFound"
      class="page-content p4a__activity-content"
    >
      <header class="p4a__header">
        <b-container>
          <b-row class="auth-inner m-0">
            <!-- Brand logo-->
            <router-link
              :to="'/appointments'"
              :class="isMobile() ? 'mx-auto' : ''"
            >
              <img :src="isMobile() ? logoMobileImg : logoImg">
            </router-link>
            <!-- /Brand logo-->
          </b-row>
        </b-container>
      </header>

      <div class="breadcrumb-block breadcrumb__mobile">
        <b-container>
          <b-row>
            <b-col>
              <b-breadcrumb class="p4a__breadcrumb">
                <b-breadcrumb-item>
                  <router-link :to="'/appointments'">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M13.1003 5.29305L7.85033 1.21435C7.61699 1.03955 7.32533 1.03955 7.15033 1.21435L1.90033 5.29305C1.72533 5.40959 1.66699 5.58439 1.66699 5.75919V12.1686C1.66699 13.1591 2.42533 13.9166 3.41699 13.9166H11.5837C12.5753 13.9166 13.3337 13.1591 13.3337 12.1686V5.75919C13.3337 5.58439 13.2753 5.40959 13.1003 5.29305ZM8.66699 8.08987V12.7512H6.33366V8.08987H8.66699ZM11.5837 12.7512C11.9337 12.7512 12.167 12.5182 12.167 12.1686V6.05052L7.50033 2.43796L2.83366 6.05052V12.1686C2.83366 12.5182 3.06699 12.7512 3.41699 12.7512H5.16699V7.5072C5.16699 7.1576 5.40033 6.92453 5.75033 6.92453H9.25032C9.60032 6.92453 9.83366 7.1576 9.83366 7.5072V12.7512H11.5837Z"
                        fill="white"
                      />
                      <mask
                        id="mask0"
                        mask-type="alpha"
                        maskUnits="userSpaceOnUse"
                        x="1"
                        y="1"
                        width="13"
                        height="13"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M13.1003 5.29305L7.85033 1.21435C7.61699 1.03955 7.32533 1.03955 7.15033 1.21435L1.90033 5.29305C1.72533 5.40959 1.66699 5.58439 1.66699 5.75919V12.1686C1.66699 13.1591 2.42533 13.9166 3.41699 13.9166H11.5837C12.5753 13.9166 13.3337 13.1591 13.3337 12.1686V5.75919C13.3337 5.58439 13.2753 5.40959 13.1003 5.29305ZM8.66699 8.08987V12.7512H6.33366V8.08987H8.66699ZM11.5837 12.7512C11.9337 12.7512 12.167 12.5182 12.167 12.1686V6.05052L7.50033 2.43796L2.83366 6.05052V12.1686C2.83366 12.5182 3.06699 12.7512 3.41699 12.7512H5.16699V7.5072C5.16699 7.1576 5.40033 6.92453 5.75033 6.92453H9.25032C9.60032 6.92453 9.83366 7.1576 9.83366 7.5072V12.7512H11.5837Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0)">
                        <rect
                          x="0.5"
                          y="0.5"
                          width="14"
                          height="14"
                          fill="black"
                        />
                      </g>
                    </svg>
                  </router-link>
                </b-breadcrumb-item>
                <b-breadcrumb-item
                  class="p4a__breadcrumb-item"
                  active
                >
                  {{ activity.typeName }} Booking
                </b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
          </b-row>
        </b-container>
      </div>

      <div
        ref="stepper_block"
        class="step-block"
        :class="{'stepper_fixed': scrolled}"
        @scroll="stepperHandleScroll"
      >
        <b-container>
          <b-row>
            <b-col>
              <b-breadcrumb>
                <b-breadcrumb-item
                  :class="{ 'active': phase == 'customerDetail', 'icon-active': getActivePhase('customerDetail') }"
                  @click="changePhaseFromBreadcrumb('customerDetail')"
                >
                  <div class="item_info">
                    <div class="item_icon p4a__activity-item_icon">
                      <feather-icon icon="UserIcon" />
                    </div>
                    <div
                      v-if="customFieldsLength"
                      class="item-text p4a__activity-item_text"
                    >
                      <h4>Details of Applicant 申请人资料</h4>
                      <p v-if="isMobile()">
                        Next: Add-on services 附加服务
                      </p>
                      <p v-else>
                        Enter your details
                      </p>
                    </div>
                    <div
                      v-else
                      class="item-text p4a__activity-item_text"
                    >
                      <h4>Details of Applicant 申请人资料</h4>
                      <p v-if="isMobile()">
                        Summary 预约摘要
                      </p>
                      <p v-else>
                        Enter your details
                      </p>
                    </div>
                  </div>

                  <div v-if="isMobile()">
                    <div
                      v-if="customFieldsLength"
                      class="circle-wrap one-third"
                    >
                      <div class="circle">
                        <div class="mask full">
                          <div class="fill" />
                        </div>
                        <div class="mask half">
                          <div class="fill" />
                        </div>
                        <div class="inside-circle">
                          1 of 3
                        </div>
                      </div>
                    </div>
                    <div
                      v-else
                      class="circle-wrap one-third"
                    >
                      <div class="circle">
                        <div class="mask full">
                          <div class="fill" />
                        </div>
                        <div class="mask half">
                          <div class="fill" />
                        </div>
                        <div class="inside-circle">
                          1 of 2
                        </div>
                      </div>
                    </div>
                  </div>
                </b-breadcrumb-item>
                <b-breadcrumb-item
                  v-if="customFieldsLength"
                  :class="{ 'active': phase == 'packageDetail', 'icon-active': getActivePhase('packageDetail') }"
                  :disabled="!enableNextPhaseCustomer"
                  @click="changePhaseFromBreadcrumb('packageDetail')"
                >
                  <div class="item_info">
                    <div class="item_icon p4a__activity-item_icon">
                      <feather-icon icon="BoxIcon" />
                    </div>
                    <div class="item-text p4a__activity-item_text">
                      <h4>Add-on services 附加服务</h4>
                      <p />
                      <p v-if="isMobile()">
                        Next: Summary 概括
                      </p>
                      <p v-else>
                        Choose add-on services
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="isMobile()"
                    class="circle-wrap two-third"
                  >
                    <div class="circle">
                      <div class="mask full">
                        <div class="fill" />
                      </div>
                      <div class="mask half">
                        <div class="fill" />
                      </div>
                      <div class="inside-circle">
                        2 of 3
                      </div>
                    </div>
                  </div>
                </b-breadcrumb-item>

                <b-breadcrumb-item
                  :class="{ 'active': phase == 'serviceDescription', 'icon-active': getActivePhase('serviceDescription') }"
                  :disabled="!enableNextPhaseCustomFields"
                  @click="changePhaseFromBreadcrumb('serviceDescription')"
                >
                  <div class="item_info">
                    <div class="item_icon p4a__activity-item_icon">
                      <feather-icon icon="ListIcon" />
                    </div>
                    <div class="item-text p4a__activity-item_text">
                      <h4>Service Description Items</h4>
                      <p v-if="!isMobile()">
                        Choose a service description
                      </p>
                    </div>
                  </div>
                </b-breadcrumb-item>

                <b-breadcrumb-item
                  :class="{ 'active': phase == 'summaryPhase', 'icon-active': getActivePhase('summaryPhase') }"
                  :disabled="!enableNextPhaseCustomFields"
                  @click="changePhaseFromBreadcrumb('summaryPhase')"
                >
                  <div class="item_info">
                    <div class="item_icon p4a__activity-item_icon">
                      <feather-icon icon="ListIcon" />
                    </div>
                    <div class="item-text p4a__activity-item_text">
                      <h4>Summary 预约摘要</h4>
                      <p v-if="!isMobile()">
                        View your booking summary
                      </p>
                    </div>
                  </div>
                  <div
                    v-if="isMobile()"
                    class="circle-wrap"
                  >
                    <div class="circle">
                      <div class="mask full">
                        <div class="fill" />
                      </div>
                      <div class="mask half">
                        <div class="fill" />
                      </div>
                      <div
                        v-if="customFieldsLength"
                        class="inside-circle"
                      >
                        3 of 3
                      </div>
                      <div
                        v-else
                        class="inside-circle"
                      >
                        2 of 2
                      </div>
                    </div>
                  </div>
                </b-breadcrumb-item>

                <b-breadcrumb-item
                  v-if="serviceOrderItems.length"
                  :class="{ 'active': phase == 'makePayment', 'icon-active': getActivePhase('makePayment') }"
                  :disabled="phase !== 'makePayment'"
                  @click="changePhaseFromBreadcrumb('makePayment')"
                >
                  <div class="item_info">
                    <div class="item_icon p4a__activity-item_icon">
                      <feather-icon icon="DollarSignIcon" />
                    </div>
                    <div class="item-text p4a__activity-item_text">
                      <h4>Make Payment</h4>
                      <p v-if="!isMobile()">
                        Pay your items
                      </p>
                    </div>
                  </div>
                </b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
          </b-row>
        </b-container>
      </div>

      <div class="events event-register main-content appointment_request_wrapper">
        <b-form @submit.prevent="submitFullForm">
          <validation-observer
            ref="frontActivityBookingCreateForm"
            #default="{invalid}"
          >
            <b-container class="activity-booking-form-container">
              <b-row class="row8">
                <b-col
                  v-if="phase == 'customerDetail'"
                  lg="8"
                  class="top-info-left"
                >
                  <b-card>
                    <b-card-text>
                      <h3 class="p4a__input-specifier__title">
                        Details of Applicant 申请人资料
                      </h3>
                      <p class="p4a__input-specifier__sub-title">
                        We will use your contact details to keep you updated regarding further details about the event registered.
                      </p>

                      <b-row>
                        <b-col
                          v-if="verifiedType != 'agent'"
                          lg="10"
                        >
                          <div class="form-row form-group">
                            <label class="col-md-5 col-form-label p4a__text-bold-gray">Applicant Name *</label>
                            <div class="col">
                              <validation-provider
                                #default="{ }"
                                name="Applicant Name"
                                vid="h-first-name"
                                rules="required"
                              >
                                <b-form-input
                                  id="h-first-name"
                                  v-model="customerName"
                                  class="p4a__activity-input"
                                  placeholder="Full Name"
                                  :state="(customerNameValidation) ? false : null"
                                  name="customerName"
                                  :disabled="customer.name ? true : false"
                                  @input="validateCustomerName"
                                />
                                <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                                <small
                                  v-if="customerNameValidation"
                                  class="text-danger"
                                >
                                  {{ customerNameError }}
                                </small>
                              </validation-provider>
                            </div>
                          </div>
                        </b-col>
                        <b-col
                          v-else
                          lg="10"
                        >
                          <div
                            class="form-row form-group search-bar p4a"
                          >
                            <label class="col-md-5 col-form-label p4a__text-bold-gray">Applicant Name *</label>
                            <div class="col">
                              <b-input-group :class="!showCustomerCrossIcon ? 'p4a__control-border-right' : 'p4a__control-border-right-off'">
                                <b-form-input
                                  id="search_name"
                                  v-model="searchInput"
                                  label="Applicant Name"
                                  name="name"
                                  class="p4a__activity-input"
                                  placeholder="Select from list or enter a name"
                                  autocomplete="off"
                                  tabindex="0"
                                  @keyup="submitSearchInput()"
                                  @focusout="resetSearchResult"
                                />
                                <b-input-group-append
                                  v-if="showCustomerCrossIcon"
                                  is-text
                                >
                                  <feather-icon
                                    icon="XIcon"
                                    class="cursor-pointer p4a__text-base-light-color"
                                    size="18"
                                    data-toggle
                                    @click="clearSearchInput"
                                  />
                                </b-input-group-append>
                              </b-input-group>

                              <div v-show="showSearchResult">
                                <div
                                  class="search-results mt-50"
                                >
                                  <div v-if="foundCustomers.length">
                                    <b-list-group
                                      flush
                                    >
                                      <span class="found-text-block p4a-color">Customers found</span>
                                      <b-list-group-item
                                        v-for="(cus, sIndex) in foundCustomers"
                                        :key="sIndex"
                                        class="cursor-pointer"
                                        @click="addSearchInputItem(cus)"
                                      >
                                        <div
                                          class="search-item-text-block"
                                        >
                                          <h6>
                                            {{ cus.name }}
                                          </h6>
                                          <br>
                                          <h6>
                                            {{ cus.perContact }} / {{ cus.encryptedNric }} {{ cus.perEmail ? `/ ${cus.perEmail}` : '' }}
                                          </h6>
                                        </div>
                                      </b-list-group-item>
                                    </b-list-group>
                                  </div>
                                </div>
                              </div>
                              <b-card
                                v-show="searchResultNotFound"
                                no-body
                                class="mt-50 mb-0"
                              >
                                <div class="p4a__result-not-found-block">
                                  <h5 class="mb-0">
                                    No result found. Continue typing to enter the applicant name.
                                  </h5>
                                </div>
                              </b-card>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row
                        v-if="!isPhoneHidden"
                        id="phone_block"
                      >
                        <b-col lg="10">
                          <div class="form-row form-group">
                            <label class="col-md-5 col-form-label p4a__text-bold-gray">Mobile Number *</label>
                            <div class="col">
                              <div class="d-flex gap-1">
                                <validation-provider
                                  #default="{}"
                                  name="Country Code"
                                  vid="h-phone-country-code"
                                  rules="required"
                                  class="w-25"
                                >
                                  <b-form-input
                                    id="h-phone-country-code"
                                    v-model="customerCountryCode"
                                    class="p4a__activity-input"
                                    placeholder="+65"
                                    name="customerCountryCode"
                                    :disabled="verifiedType != 'agent'"
                                  />
                                </validation-provider>
                                <validation-provider
                                  #default="{ }"
                                  name="Applicant Mobile"
                                  vid="h-phone-number"
                                  class="w-75"
                                >
                                  <!-- <cleave
                                    v-if="verifiedType == 'agent'"
                                    id="h-phone-number"
                                    v-model="customerContact"
                                    class="form-control p4a__activity-input"
                                    :raw="false"
                                    :options="options.prefix"
                                    :disabled="existingCustomer"
                                    @input="validateCustomerContact"
                                  /> -->
                                  <b-form-input
                                    id="h-phone-number"
                                    v-model="customerContact"
                                    class="p4a__activity-input"
                                    placeholder="8 Digits Phone Number"
                                    :state="(customerContactValidation) ? false : null"
                                    name="customerContact"
                                    :disabled="verifiedType != 'agent'"
                                    @input="validateCustomerContact"
                                  />
                                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                                  <small
                                    v-if="customerContactValidation"
                                    class="text-danger"
                                  >
                                    {{ customerContactError }}
                                  </small>
                                </validation-provider>
                              </div>
                            </div>
                          </div>
                        </b-col>

                        <!-- <b-col
                          v-if="verifiedType == 'agent'"
                          lg="10"
                        >
                          <b-row>
                            <b-col md="5" />
                            <b-col
                              md="7"
                              class="use_email"
                            >
                              <b-button
                                variant="link"
                                class="p4a__text-base-color phone-email-button text-left"
                                @click="isPhoneHidden = true; isEmailHidden = false; customerContact = ''"
                              >
                                Not from Singapore? Use email instead
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col> -->
                      </b-row>
                      <!-- <b-row
                        v-if="!isEmailHidden"
                        id="email_block"
                      >
                        <b-col lg="10">
                          <div class="form-row form-group">
                            <label class="col-md-5 col-form-label p4a__text-bold-gray">Email Address*</label>
                            <div class="col">
                              <validation-provider
                                #default="{ }"
                                name="Applicant Email"
                                vid="h-customer-email"
                                :rules="isEmailHidden === false ? 'required' : ''"
                              >
                                <b-form-input
                                  id="h-customer-email"
                                  v-model="customerEmail"
                                  class="p4a__activity-input"
                                  placeholder="E-mail Address"
                                  :state="(customerEmailValidation) ? false : null"
                                  name="customerEmail"
                                  :disabled="verifiedType == 'agent' ? false : true"
                                  @input="validateCustomerEmail"
                                />
                                <small
                                  v-if="customerEmailValidation"
                                  class="text-danger"
                                >
                                  {{ customerEmailError }}
                                </small>
                              </validation-provider>
                            </div>
                          </div>
                        </b-col>

                        <b-col
                          v-if="verifiedType == 'agent'"
                          lg="10"
                        >
                          <b-row>
                            <b-col md="5" />
                            <b-col
                              md="7"
                              class="use_email"
                            >
                              <b-button
                                variant="link"
                                class="p4a__text-base-color phone-email-button text-left"
                                @click="isPhoneHidden = false; isEmailHidden = true; customerEmail = ''"
                              >
                                Use mobile number instead
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row> -->
                      <b-row
                        id="email_block"
                      >
                        <b-col lg="10">
                          <div class="form-row form-group">
                            <label class="col-md-5 col-form-label p4a__text-bold-gray">Email Address*</label>
                            <div class="col">
                              <validation-provider
                                #default="{ }"
                                name="Applicant Email"
                                vid="h-customer-email"
                                rules="required|email"
                              >
                                <b-form-input
                                  id="h-customer-email"
                                  v-model="customerEmail"
                                  class="p4a__activity-input"
                                  placeholder="E-mail Address"
                                  :state="(customerEmailValidation) ? false : null"
                                  name="customerEmail"
                                  :disabled="customerContactType == 'email' ? true : false"
                                  @input="validateCustomerEmail"
                                />
                                <small
                                  v-if="customerEmailValidation"
                                  class="text-danger"
                                >
                                  {{ customerEmailError }}
                                </small>
                              </validation-provider>
                            </div>
                          </div>
                        </b-col>

                        <!-- <b-col
                          v-if="verifiedType == 'agent'"
                          lg="10"
                        >
                          <b-row>
                            <b-col md="5" />
                            <b-col
                              md="7"
                              class="use_email"
                            >
                              <b-button
                                variant="link"
                                class="p4a__text-base-color phone-email-button text-left"
                                @click="isPhoneHidden = false; isEmailHidden = true; customerEmail = ''"
                              >
                                Use mobile number instead
                              </b-button>
                            </b-col>
                          </b-row>
                        </b-col> -->
                      </b-row>
                      <b-row
                        v-if="showNotificationWarning"
                        class="mt-1"
                      >
                        <b-col md="12">
                          <b-alert
                            variant="warning"
                            show
                            class="mt-50 mb-0"
                          >
                            <div class="alert-body d-flex">
                              <feather-icon
                                icon="InfoIcon"
                                size="40"
                                class="my-auto mr-1"
                              />
                              <div>
                                <span class="weight-400 fs-14">From 1 March 2026 onwards, notifications of appointment booking will be sent via email instead of SMS. 从2026年1月1日起，预约通知将通过电子邮件发送，不再使用短信。</span>
                              </div>
                            </div>
                          </b-alert>
                        </b-col>
                      </b-row>
                      <hr class="p4a__hr-base-border">
                      <h3 class="p4a__input-specifier__title">
                        Your Agent Details 代理人资料
                      </h3>
                      <p />
                      <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis.</p> -->

                      <b-row>
                        <b-col lg="10">
                          <b-form-group
                            label="Agent Name"
                            label-class="p4a__text-bold-gray"
                            label-for="h-agent-name"
                            label-cols-md="5"
                          >
                            <b-form-input
                              id="h-agent-name"
                              v-model="agentName"
                              class="p4a__activity-input"
                              placeholder="Agent Name"
                              :disabled="verifiedType == 'agent' ? true : false"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col lg="10">
                          <b-form-group
                            label="Agent Code"
                            label-class="p4a__text-bold-gray"
                            label-for="h-agent-code"
                            label-cols-md="5"
                          >
                            <b-form-input
                              id="h-agent-code"
                              v-model="agentCode"
                              class="p4a__activity-input"
                              type="text"
                              placeholder="Agent Code"
                              :disabled="verifiedType == 'agent' ? true : false"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <hr class="p4a__hr-base-border">
                      <b-row>
                        <b-col cols="12">
                          <h3 class="p4a__input-specifier__title">
                            Remarks / Notes 备注
                          </h3>
                          <b-form-textarea
                            id="textarea-default"
                            v-model="remarks"
                            class="p4a__activity-input"
                            placeholder="E.g. Please contact me during daytime."
                            rows="3"
                          />
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>

                  <b-card>
                    <b-card-text>
                      <h3 class="p4a__input-specifier__title">
                        Timeslots Booking {{ activity.timeSlotTitleSG }}
                      </h3>
                      <p />

                      <b-alert
                        v-if="existingBookingWarning"
                        variant="danger"
                        show
                      >
                        <div class="alert-body">
                          <span>You have an existing booking for this timeslot. As a result, your new booking may be subject to further approval by one of our Duty Officers. Choose a different timeslot to avoid this.</span>
                        </div>
                      </b-alert>

                      <b-row class="time__slots">
                        <b-col lg="12">
                          <b-form-group
                            label="Choose a Date"
                            label-class="p4a__text-bold-gray"
                            label-for="h-start"
                            label-cols-md="4"
                          >
                            <b-input-group class="p4a__flat-pickr-wrapper">
                              <flat-pickr
                                id="h-event-start"
                                ref="datePicker"
                                v-model="start"
                                class="form-control flat-pickr-group"
                                :config="flatPickrConfig"
                                @on-change="validateStartDate"
                              />
                              <b-input-group-append is-text>
                                <feather-icon
                                  icon="CalendarIcon"
                                  class="cursor-pointer p4a__text-base-light-color"
                                  data-toggle
                                  size="18"
                                />
                              </b-input-group-append>
                            </b-input-group>

                            <small
                              v-if="startValidation"
                              class="text-danger"
                            >
                              {{ startError }}
                            </small>
                          </b-form-group>
                        </b-col>

                        <b-col
                          cols="12"
                          class="mb-margin-0"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Start Time"
                            vid="h-start-time"
                            rules="required"
                          >
                            <b-form-group
                              label="Choose a Timeslot"
                              label-class="p4a__text-bold-gray"
                              label-for="h-start-time"
                              label-cols-md="4"
                            >
                              <b-row class="row5">
                                <b-col
                                  v-for="(option, index) in timeSlots"
                                  :key="index"
                                  md="4"
                                  cols="6"
                                >
                                  <b-form-radio
                                    v-model="startTime"
                                    name="timeslot"
                                    :value="option.timeValue"
                                    class="mb-50 p4a__radio-input"
                                    :disabled="option.status !== 'enabled'"
                                    :state="(errors.length > 0) ? false : null"
                                    @change="validateStartTime"
                                  >
                                    <span>{{ option.time }}</span>
                                  </b-form-radio>
                                </b-col>
                              </b-row>
                            </b-form-group>

                            <small
                              v-if="startTimeValidation"
                              class="text-danger"
                            >
                              {{ startTimeError }}
                            </small>
                            <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                          </validation-provider>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>
                </b-col>

                <b-col
                  v-if="phase == 'packageDetail'"
                  lg="8"
                  class="top-info-left"
                >
                  <b-card>
                    <b-row
                      v-for="(opt, key) in activity.customFields"
                      :key="key"
                    >
                      <b-col
                        v-if="opt.type == 'file' || opt.type == 'title-and-text'"
                        lg="12"
                      >
                        <div
                          v-if="opt.type == 'file'"
                          class="details_img"
                        >
                          <img :src="opt.file">
                        </div>

                        <div v-if="opt.type == 'title-and-text'">
                          <h3 class="p4a__input-specifier__title">
                            {{ opt.label }}
                          </h3>
                          <p class="p4a__input-specifier__sub-title">
                            {{ opt.description }}
                          </p>
                        </div>
                      </b-col>

                      <b-col
                        v-if="!['file', 'title-and-text'].includes(opt.type)"
                        lg="12"
                      >
                        <b-form-group
                          v-if="opt.type == 'short-answer'"
                          :label="opt.label"
                          :label-for="'event-custom-field-' + key"
                          label-class="p4a__input-specifier__title"
                          label-cols-md="12"
                        >
                          <div class="p4a__input-specifier__sub-title mb-50">
                            {{ opt.description }}
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="opt.label"
                            :vid="'event-custom-field-' + key"
                            :rules="opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-input
                              :id="'event-custom-field-' + key"
                              v-model="customFields[key].value"
                              :placeholder="opt.label"
                              :state="(errors.length > 0) ? false : null"
                              @input="enableNextPhaseCustomFieldsDetail"
                            />
                          </validation-provider>
                        </b-form-group>

                        <b-form-group
                          v-if="opt.type == 'long-answer'"
                          :label="opt.label"
                          :label-for="'event-custom-field-' + key"
                          label-class="p4a__input-specifier__title"
                          label-cols-md="12"
                        >
                          <div class="p4a__input-specifier__sub-title mb-50">
                            {{ opt.description }}
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="opt.label"
                            :vid="'event-custom-field-' + key"
                            :rules="opt.required == 'yes' ? 'required' : ''"
                          >
                            <b-form-textarea
                              :id="'event-custom-field-' + key"
                              v-model="customFields[key].value"
                              trim
                              :placeholder="opt.label"
                              :state="(errors.length > 0) ? false : null"
                              @input="enableNextPhaseCustomFieldsDetail"
                            />
                          </validation-provider>
                        </b-form-group>

                        <b-form-group
                          v-if="opt.type == 'multi-select' && opt.multiSelectType == 'multiple'"
                          label-cols-md="12"
                          :label="opt.label"
                          :label-for="'event-custom-field-' + key"
                          label-class="p4a__input-specifier__title"
                        >
                          <div class="p4a__input-specifier__sub-title mb-50">
                            {{ opt.description }}
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="opt.label"
                            :rules="opt.required == 'yes' ? 'required' : ''"
                          >

                            <b-form-checkbox-group
                              :id="'event-custom-field-' + key"
                              v-model="customFields[key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                              :state="(errors.length > 0) ? false : null"
                              @change="enableNextPhaseCustomFieldsDetail"
                            >
                              <b-form-checkbox
                                v-for="(option, kindex) in opt.extraOptions"
                                :key="kindex"
                                :value="option.key"
                                class="mb-50 p4a__site-booking-checkbox"
                              >
                                <feather-icon
                                  v-if="customFields[key].value.includes(option.key)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ option.key }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group
                          v-if="opt.type == 'multi-select' && opt.multiSelectType == 'single'"
                          :label="opt.label"
                          :label-for="'event-custom-field-' + key"
                          label-class="p4a__input-specifier__title"
                          label-cols-md="12"
                          class="mb-margin-0"
                        >
                          <div class="p4a__input-specifier__sub-title mb-50">
                            {{ opt.description }}
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="opt.label"
                            :rules="opt.required == 'yes' ? 'required' : ''"
                          >
                            <!-- <b-form-radio-group
                              :id="'event-custom-field-' + key"
                              v-model="customFields[key].value"
                              button-variant="outline-primary"
                              buttons
                              class="spaceBetweenRadio"
                              :state="(errors.length > 0) ? false : null"
                              @change="enableNextPhaseCustomFieldsDetail"
                            >
                              <b-form-radio
                                v-for="(option, kindex) in opt.extraOptions"
                                :key="kindex"
                                :value="option.key"
                                class="mb-50"
                              >
                                <feather-icon
                                  v-if="customFields[key].value === option.key"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ option.key }}</span>
                              </b-form-radio>
                            </b-form-radio-group> -->

                            <b-form-checkbox-group
                              :id="'event-custom-field-' + key"
                              v-model="customFields[key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                              :state="(errors.length > 0) ? false : null"
                              @input="makeCheckboxToRadio(key)"
                            >
                              <b-form-checkbox
                                v-for="(option, kindex) in opt.extraOptions"
                                :key="kindex"
                                :value="option.key"
                                class="mb-50 p4a__site-booking-checkbox"
                              >
                                <feather-icon
                                  v-if="customFields[key].value.includes(option.key)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ option.key }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group
                          v-if="opt.type == 'single-select'"
                          label-cols-md="12"
                          :label="opt.label"
                          :label-for="'event-custom-field-' + key"
                        >
                          <div class="p4a__input-specifier__sub-title mb-50">
                            {{ opt.description }}
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="opt.label"
                            :rules="opt.required == 'yes' ? 'required' : ''"
                          >

                            <!-- <b-form-radio-group
                              :id="'event-custom-field-' + key"
                              v-model="customFields[key].value"
                              button-variant="outline-primary"
                              buttons
                              class="spaceBetweenRadio"
                              :state="(errors.length > 0) ? false : null"
                              @change="enableNextPhaseCustomFieldsDetail"
                            >
                              <b-form-radio
                                v-for="(option, kindex) in requiredOptions"
                                :key="kindex"
                                :value="option.value"
                              >
                                <feather-icon
                                  v-if="customFields[key].value === option.value"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ option.text }}</span>
                              </b-form-radio>
                            </b-form-radio-group> -->
                            <b-form-checkbox-group
                              :id="'event-custom-field-' + key"
                              v-model="customFields[key].value"
                              buttons
                              button-variant="outline-primary"
                              class="spaceBetweenRadio display-block-checkbox"
                              :state="(errors.length > 0) ? false : null"
                              @input="makeCheckboxToRadio(key)"
                            >
                              <b-form-checkbox
                                v-for="(option, kindex) in requiredOptions"
                                :key="kindex"
                                :value="option.value"
                                class="mb-50 p4a__site-booking-checkbox"
                              >
                                <feather-icon
                                  v-if="customFields[key].value.includes(option.value)"
                                  icon="CheckIcon"
                                  class="mr-50"
                                  size="16"
                                />
                                <span class="align-middle">{{ option.text }}</span>
                              </b-form-checkbox>
                            </b-form-checkbox-group>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>

                <b-col
                  v-if="phase == 'serviceDescription'"
                  lg="8"
                  class="top-info-left"
                >
                  <b-card class="custom_offering_card">
                    <b-card-text>
                      <div
                        v-for="(group, gIndex) in serviceDescriptionGroupsFor(sdFields)"
                        :key="gIndex"
                        class="offering_group_block"
                      >
                        <template
                          v-for="entry in group"
                        >
                          <template v-if="entry.opt.showInFrontend === 'yes' || isParentGroupTitle(entry.opt, sdFields)">
                            <h3
                              v-if="entry.opt.type === 'title-and-text'"
                              :key="entry.key"
                              class="p4a__input-specifier__title offer_top_tittle"
                            >
                              {{ entry.opt.label }}
                            </h3>

                            <b-row
                              v-else-if="entry.opt.type === 'increment'"
                              :key="entry.key"
                              class="sr__offering-row offering_custom_row"
                            >
                              <b-col cols="9">
                                <p class="p4a__text-bold-gray mb-0">
                                  {{ entry.opt.baseLabel || entry.opt.label }} S${{ linePrice(entry.opt.label, entry.opt.tagProductPrice) }}
                                </p>
                              </b-col>
                              <b-col
                                cols="3"
                                class="d-flex align-items-center justify-content-end sr__qty-stepper"
                              >
                                <div class="qty_rt_ap_block">
                                  <button
                                    type="button"
                                    class="sr__qty-btn"
                                    @click="decrementSdField(entry.key)"
                                  >
                                    <feather-icon
                                      icon="MinusIcon"
                                      size="14"
                                    />
                                  </button>
                                  <span class="sr__qty-value">{{ sdServiceDescription[entry.key].value }}</span>
                                  <button
                                    type="button"
                                    class="sr__qty-btn"
                                    @click="incrementSdField(entry.key)"
                                  >
                                    <feather-icon
                                      icon="PlusIcon"
                                      size="14"
                                    />
                                  </button>
                                </div>
                              </b-col>
                            </b-row>

                            <b-row v-else-if="entry.opt.type === 'multi-select' && (entry.opt.extraOptions || []).length" :key="entry.key">
                              <b-col cols="12">
                                <h3
                                  v-if="!isParentGroupTitle(entry.opt, sdFields)"
                                  class="p4a__input-specifier__title"
                                >
                                  {{ entry.opt.label }}
                                </h3>
                                <button
                                  v-for="(optn, oIndex) in entry.opt.extraOptions"
                                  :key="oIndex"
                                  type="button"
                                  class="sr__chip-btn"
                                  :class="{ 'sr__chip-btn--active': sdServiceDescription[entry.key].value.includes(optn.key) }"
                                  @click="toggleSdMultiSelect(entry.key, optn.key)"
                                >
                                  <feather-icon
                                    v-if="sdServiceDescription[entry.key].value.includes(optn.key)"
                                    icon="CheckIcon"
                                    size="14"
                                    class="mr-50"
                                  />
                                  {{ optn.value }}
                                </button>
                              </b-col>
                            </b-row>

                            <b-row v-else-if="entry.opt.type === 'single-select'" :key="entry.key">
                              <b-col cols="12">
                                <button
                                  type="button"
                                  class="sr__chip-btn"
                                  :class="{ 'sr__chip-btn--active': sdServiceDescription[entry.key].value.includes('yes') }"
                                  @click="toggleSdSingleSelect(entry.key)"
                                >
                                  <feather-icon
                                    v-if="sdServiceDescription[entry.key].value.includes('yes')"
                                    icon="CheckIcon"
                                    size="14"
                                    class="mr-50"
                                  />
                                  {{ entry.opt.label }}
                                </button>
                              </b-col>
                            </b-row>

                            <b-form-group
                              v-else-if="entry.opt.type === 'dropdown'"
                              :key="entry.key"
                              :label="entry.opt.label"
                              class="service-description"
                              label-class="p4a__text-bold-gray"
                            >
                              <v-select
                                v-model="sdServiceDescription[entry.key].value"
                                label="value"
                                placeholder="Select From List"
                                :options="entry.opt.extraOptions"
                                :reduce="value => value.key"
                                :clearable="true"
                              />
                            </b-form-group>

                            <b-form-group
                              v-else-if="entry.opt.type === 'short-answer'"
                              :key="entry.key"
                              :label="entry.opt.label"
                              class="service-description"
                              label-class="p4a__text-bold-gray"
                            >
                              <b-form-input
                                v-model="sdServiceDescription[entry.key].value"
                                class="mobile-input__value-adjust p4a__activity-input"
                                :placeholder="entry.opt.label"
                              />
                            </b-form-group>

                            <b-form-group
                              v-else-if="entry.opt.type === 'long-answer'"
                              :key="entry.key"
                              :label="entry.opt.label"
                              class="service-description"
                              label-class="p4a__text-bold-gray"
                            >
                              <b-form-textarea
                                v-model="sdServiceDescription[entry.key].value"
                                trim
                                class="mobile-input__value-adjust p4a__activity-input"
                                :placeholder="entry.opt.label"
                              />
                            </b-form-group>
                          </template>
                        </template>
                      </div>

                      <div class="offering_group_block">
                        <b-row>
                          <b-col cols="12">
                            <h3 class="p4a__input-specifier__title">
                              Other Requests 其他需求
                            </h3>
                            <b-form-textarea
                              id="sr-other-requests"
                              v-model="otherRequestsSR"
                              class="p4a__activity-input"
                              placeholder="Optional (for offering)"
                              rows="3"
                            />
                          </b-col>
                        </b-row>
                      </div>
                    </b-card-text>
                  </b-card>
                </b-col>

                <b-col
                  v-if="phase == 'summaryPhase'"
                  lg="8"
                  class="top-info-left"
                >
                  <b-card>
                    <button
                      class="btn btn-link p4a__back-btn"
                      type="button"
                      @click="phase = 'customerDetail'"
                    >
                      Back to editing
                    </button>
                    <b-card-text class="applicant__details">
                      <h3 class="p4a__input-specifier__title">
                        Details of Applicant 申请人资料
                      </h3>
                      <p class="p4a__input-specifier__sub-title">
                        We will use your contact details to keep you updated regarding further details about the event registered.
                      </p>

                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="3">
                          <strong>Applicant Name</strong>
                        </b-col>
                        <b-col md="9">
                          <p>{{ customerName || '-' }}</p>
                        </b-col>
                      </b-row>

                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="3">
                          <strong>Mobile Number</strong>
                        </b-col>
                        <b-col md="9">
                          <p>{{ customerContact ? customerCountryCode : '' }}{{ customerContact || '-' }}</p>
                        </b-col>
                      </b-row>

                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="3">
                          <strong>Email</strong>
                        </b-col>
                        <b-col md="9">
                          <p>{{ customerEmail || '-' }}</p>
                        </b-col>
                      </b-row>
                      <hr class="p4a__hr-base-border">
                      <h3 class="p4a__input-specifier__title">
                        Your Agent Details 代理人资料
                      </h3>
                      <p />
                      <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis.</p> -->

                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="3">
                          <strong>Agent Name</strong>
                        </b-col>
                        <b-col md="9">
                          <p>{{ agentName || '-' }}</p>
                        </b-col>
                      </b-row>

                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="3">
                          <strong>Agent Code</strong>
                        </b-col>
                        <b-col md="9">
                          <p>{{ agentCode || '-' }}</p>
                        </b-col>
                      </b-row>

                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="3">
                          <strong>Agent Contact</strong>
                        </b-col>
                        <b-col md="9">
                          <p>{{ agentContact || '-' }}</p>
                        </b-col>
                      </b-row>

                      <hr class="p4a__hr-base-border">
                      <b-row>
                        <b-col cols="12">
                          <h3 class="p4a__input-specifier__title">
                            Remarks / Notes 备注
                          </h3>
                          <p class="p4a_input-value-text line-breaks-textarea">
                            {{ remarks || '-' }}
                          </p>
                        </b-col>
                      </b-row>

                      <hr class="p4a__hr-base-border">
                      <b-row>
                        <b-col cols="12">
                          <h3 class="p4a__input-specifier__title">
                            Timeslots Booking 选择拜祭时段
                          </h3>
                          <p class="p4a_input-value-text">
                            {{ start }}, {{ startTime ? dateFormatFromTimeStringWithoutTimezone(startTime) : '' }}
                          </p>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>

                  <b-card
                    v-if="serviceOrderItems.length"
                    class="order-items-details custom_sp_od"
                  >
                    <b-card-text>
                      <b-row class="align-items-center">
                        <b-col cols="6">
                          <h3 class="p4a__input-specifier__title mb-0">
                            Order Items
                          </h3>
                        </b-col>
                        <b-col
                          cols="6"
                          class="text-right"
                        >
                          <button
                            class="btn btn-link sr__link-btn p-0"
                            type="button"
                            @click="phase = 'serviceDescription'"
                          >
                            Edit order item(s)
                          </button>
                        </b-col>
                      </b-row>
                      <b-row
                        v-for="(item, index) in serviceOrderItems"
                        :key="index"
                        class="sum_list p4a__input-value-preview align-items-start"
                      >
                        <b-col md="9">
                          <p class="mb-0">
                            {{ item.label }} S${{ item.price }}
                          </p>
                        </b-col>
                        <b-col
                          md="3"
                          class="text-right"
                        >
                          <p class="mb-0">
                            ${{ formatCurrency(item.price * item.qty) }}
                          </p>
                          <span class="sr__qty-badge">{{ item.qty }}</span>
                        </b-col>
                      </b-row>

                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="9">
                          <p class="mb-0">
                            Subtotal
                          </p>
                        </b-col>
                        <b-col
                          md="3"
                          class="text-right"
                        >
                          <p class="mb-0">
                            <strong>${{ formatCurrency(serviceSubtotal) }}</strong>
                          </p>
                        </b-col>
                      </b-row>
                      <b-row class="sum_list p4a__input-value-preview inculsive_row_sp">
                        <b-col md="9">
                          <p class="mb-0">
                            Inclusive GST (9%)
                          </p>
                        </b-col>
                        <b-col
                          md="3"
                          class="text-right"
                        >
                          <p class="mb-0">
                            (${{ formatCurrency(serviceGst) }})
                          </p>
                        </b-col>
                      </b-row>
                      <b-row class="sum_list p4a__input-value-preview">
                        <b-col md="9">
                          <p class="mb-0">
                            <strong>Total</strong>
                          </p>
                        </b-col>
                        <b-col
                          md="3"
                          class="text-right"
                        >
                          <p class="mb-0">
                            <strong>${{ formatCurrency(serviceSubtotal) }}</strong>
                          </p>
                        </b-col>
                      </b-row>
                    </b-card-text>
                  </b-card>

                  <b-card
                    v-if="customFieldsLength"
                    class="package-details"
                  >
                    <button
                      class="btn btn-link p4a__back-btn"
                      type="button"
                      @click="phase = 'packageDetail'"
                    >
                      Back to editing
                    </button>
                    <h3 class="p4a__input-specifier__title">
                      Add-on Services 附加服务
                    </h3>
                    <b-row
                      v-for="(opt, key) in customFields"
                      :key="key"
                      class="sum_list p4a__input-value-preview"
                    >
                      <b-col
                        v-if="opt.field != 'title-and-text' && opt.field != 'file'"
                        md="3"
                      >
                        <strong>{{ opt.key }}</strong>
                      </b-col>
                      <b-col
                        md="9"
                      >
                        <div v-if="Array.isArray(opt.value) && opt.value.length > 0">
                          <p
                            v-for="(option, index) in opt.value"
                            :key="index"
                          >
                            {{ option || '-' }} <span v-if="index + 1 != opt.value.length">, </span>
                          </p>
                        </div>
                        <div v-else>
                          <p class="text-capitalize">
                            {{ Array.isArray(opt.value) ? ('-') : ((opt.field != 'title-and-text' && opt.field != 'file') ? (opt.value || '-') : '') }}
                          </p>
                        </div>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-col>

                <b-col
                  v-if="phase == 'makePayment' && makePaymentStep == 'form'"
                  md="8"
                  offset-md="2"
                  class="top-info-left"
                >
                  <b-card class="payment-form_stv">
                    <b-card-text>
                      <div class="stv_tittle_top">
                        <h3 class="p4a__input-specifier__title">
                          Total payable now
                        </h3>
                        <p class="p4a__input-specifier__sub-title">
                          ${{ formatCurrency(serviceTotal) }}
                        </p>
                      </div>

                      <hr class="p4a__hr-base-border">
                      <div class="stv_payment_form_wrapper">
                        <template v-if="selectedPaymentMode === 'card'">
                          <b-row>
                            <b-col lg="12">
                              <b-form-group
                                label="Name on card*"
                                label-class="p4a__text-bold-gray"
                                label-for="h-card-name"
                                label-cols-md="5"
                              >
                                <b-form-input
                                  id="h-card-name"
                                  v-model="cardholderName"
                                  class="p4a__activity-input"
                                  placeholder="First name and last name"
                                  :state="cardNameValidation ? false : null"
                                  @input="cardNameValidation = false"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col lg="12">
                              <b-form-group
                                label="Card number*"
                                label-class="p4a__text-bold-gray"
                                label-for="h-card-number"
                                label-cols-md="5"
                              >
                                <cleave
                                  id="h-card-number"
                                  v-model="cardNumber"
                                  class="form-control p4a__activity-input"
                                  :raw="false"
                                  :options="cleaveOptions.creditCard"
                                  :state="cardNumberValidation ? false : null"
                                  placeholder="0000 0000 0000 0000"
                                  @input="cardNumberValidation = false"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col lg="6">
                              <b-form-group
                                label="Expiry Date*"
                                label-class="p4a__text-bold-gray"
                                label-for="h-card-expiry"
                                label-cols-md="8"
                              >
                                <cleave
                                  id="h-card-expiry"
                                  v-model="cardExpiry"
                                  class="form-control p4a__activity-input"
                                  :raw="false"
                                  :options="cleaveOptions.date"
                                  :state="cardExpiryValidation ? false : null"
                                  placeholder="mm/yy"
                                  @input="cardExpiryValidation = false"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col lg="6">
                              <b-form-group
                                label="CVV*"
                                label-class="p4a__text-bold-gray"
                                label-for="h-card-cvv"
                                label-cols-md="8"
                              >
                                <cleave
                                  id="h-card-cvv"
                                  v-model="cardCvv"
                                  class="form-control p4a__activity-input"
                                  :raw="false"
                                  :options="cleaveOptions.cardCvv"
                                  :state="cardCvvValidation ? false : null"
                                  placeholder="3 digits"
                                  @input="cardCvvValidation = false"
                                />
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </template>
                        <div
                          v-else-if="selectedPaymentMode === 'googlepay'"
                          class="text-center mb-2"
                        >
                          <p>Tap the button below to pay with Google Pay.</p>
                          <google-pay-button
                            environment="TEST"
                            button-color="black"
                            button-type="pay"
                            :payment-request.prop="googlePayRequest"
                            @loadpaymentdata="onGooglePayLoadPaymentData"
                            @error="onGooglePayError"
                          />
                        </div>
                        <template v-else>
                          <p class="p4a_input-value-text">
                            You will be redirected to complete payment via {{ paymentModes.find(m => m.key === selectedPaymentMode) ? paymentModes.find(m => m.key === selectedPaymentMode).label : '' }}.
                          </p>
                        </template>

                        <small
                          v-if="paymentErrorMessage"
                          class="text-danger d-block text-center mb-1"
                        >
                          {{ paymentErrorMessage }}
                        </small>

                        <button
                          v-if="selectedPaymentMode !== 'googlepay'"
                          type="button"
                          class="btn p4a__common-btn w-100"
                          block
                          :disabled="paymentProcessing"
                          @click="confirmAndPay"
                        >
                          <feather-icon
                            icon="DollarSignIcon"
                            class="mr-50"
                            size="16"
                          />
                          {{ paymentProcessing ? 'Processing...' : 'Confirm and pay' }}
                        </button>
                      </div>
                      <p class="text-center mt-1 p4a__text-base-light-color paymentGroup_stv">
                        <feather-icon
                          icon="LockIcon"
                          size="14"
                          class="mr-50"
                        />
                        Secure payment
                        <b-img
                          :src="paymentCardIcon"
                          alt="Visa"
                          height="24"
                          class="mr-24_pm"
                        />
                      </p>
                    </b-card-text>
                  </b-card>
                </b-col>

                <b-col
                  v-if="phase == 'makePayment' && makePaymentStep == 'paynow-qr'"
                  md="6"
                  offset-md="3"
                  class="top-info-left"
                >
                  <b-card class="text-center">
                    <b-card-text>
                      <h3 class="p4a__input-specifier__title">
                        Scan the QR code to pay
                      </h3>
                      <p class="text-muted">
                        {{ payNowTimeRemaining }}
                      </p>
                      <b-img
                        v-if="payNowQRImage"
                        :src="payNowQRImage"
                        fluid
                        class="mb-1"
                        alt="PayNow QR code"
                      />
                      <h3 class="mb-1">
                        ${{ formatCurrency(serviceTotal) }}
                      </h3>
                      <p class="text-muted mb-0">
                        Please scan this QR code using any PayNow-supported banking app to complete your payment.
                      </p>
                    </b-card-text>
                  </b-card>
                </b-col>

                <b-col
                  v-if="phase !== 'makePayment'"
                  ref="sticky_sidebar"
                  lg="4"
                  class="top-info-right "
                >
                  <vue-sticky-sidebar
                    class="sidebar"
                    container-selector=".activity-booking-form-container"
                    inner-wrapper-selector=".sidebar__inner"
                  >
                    <b-card
                      no-body
                      class="sticky_sidebar sidebarWthdCupon_wrap"
                    >
                      <div class="event-info p4a__event-info-wrapper event_offering_sidebar">
                        <div class="event_offering_sidebar_inner">
                          <h3 class="p4a__input-specifier__title">
                            {{ activity.typeName }}
                          </h3>
                          <ul class="event_info p4a__event-info">
                            <li class="event_date">
                              <span v-if="start">
                                {{ start || '-' }}, {{ startTime ? dateFormatFromTimeStringWithoutTimezone(startTime) : '-' }}
                                <br>
                                {{ dateFormatWithoutTimezoneMandarin(start) || '-' }}, {{ startTime ? dateFormatFromTimeStringWithoutTimezoneMandarin(startTime) : '-' }}
                              </span>
                              <span v-else>-<br>-</span>
                            </li>
                            <li class="event_location">
                              {{ activity.location }}<br>{{ activity.locationSG }}
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        v-if="phase === 'summaryPhase' && serviceOrderItems.length"
                        class="p4a__order-items-block offering_item_block_cs"
                      >
                        <div class="offering_ttl_st">
                          <div class="d-flex justify-content-between">
                            <span>Subtotal ({{ serviceOrderItems.length }} items)</span>
                            <span><strong>${{ formatCurrency(serviceSubtotal) }}</strong></span>
                          </div>
                          <div class="d-flex justify-content-between">
                            <span>Inclusive GST (9%)</span>
                            <span>(${{ formatCurrency(serviceGst) }})</span>
                          </div>
                        </div>
                        <div
                          v-if="appliedCoupon"
                          class="d-flex justify-content-between align-items-center"
                        >
                          <span>Coupon: {{ appliedCoupon.label }}</span>
                          <span>
                            – ${{ formatCurrency(appliedCoupon.discountAmount) }}
                            <feather-icon
                              icon="XIcon"
                              size="14"
                              class="text-danger cursor-pointer ml-50"
                              @click="removeCoupon"
                            />
                          </span>
                        </div>
                        <hr class="p4a__hr-base-border">
                        <div class="p4a__coupon-block">
                          <label
                            class="p4a__text-bold-gray"
                            for="h-coupon-code"
                          >Have coupon code?</label>
                          <b-input-group>
                            <b-form-input
                              id="h-coupon-code"
                              v-model="couponCode"
                              placeholder="Enter coupon code"
                              :disabled="couponState === 'applying'"
                            />
                            <b-input-group-append>
                              <b-button
                                variant="flat"
                                :disabled="couponState === 'applying' || !couponCode"
                                @click="applyCoupon"
                              >
                                <template v-if="couponState === 'applying'">
                                  <b-spinner small /> Applying
                                </template>
                                <template v-else>
                                  Apply
                                </template>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                          <small
                            v-if="couponState === 'invalid'"
                            class="text-danger d-block mt-50"
                          >
                            {{ couponError }}
                          </small>
                          <small
                            v-if="couponState === 'applied'"
                            class="text-success d-block mt-50"
                          >
                            Coupon applied!
                          </small>
                        </div>
                        <div class="d-flex justify-content-between font-weight-bold sd_sb_bt_last">
                          <span>Total payable now</span>
                          <span>${{ formatCurrency(serviceTotal) }}</span>
                        </div>
                      </div>

                      <div
                        v-if="phase === 'serviceDescription'"
                        class="p4a__order-items-block offering_item_block_cs"
                      >
                        <h3 class="p4a__input-specifier__title">
                          Order Items
                        </h3>
                        <div
                          v-if="!serviceOrderItems.length"
                          class="empty_item_block_cs"
                        >
                          <p class="p4a_input-value-text">
                            Cart is currently empty.
                          </p>
                        </div>
                        <div v-else>
                          <div
                            v-for="(item, index) in serviceOrderItems"
                            :key="index"
                            class="sr__order-item-row"
                          >
                            <div class="d-flex justify-content-between align-items-start">
                              <p class="mb-0">
                                {{ item.label }}
                              </p>
                              <span class="sr__item-price">${{ formatCurrency(item.price * item.qty) }}</span>
                            </div>
                            <div class="d-flex justify-content-between align-items-center mt-50 sr_ftr_btn">
                              <button
                                class="btn btn-link sr__link-btn p-0"
                                type="button"
                                @click="removeServiceOrderItem(item)"
                              >
                                Remove
                              </button>
                              <span class="sr__qty-badge">{{ item.qty }}</span>
                            </div>
                          </div>
                          <hr class="p4a__hr-base-border">
                          <div class="sb_sd_total_block">
                            <div class="d-flex justify-content-between">
                              <span>Subtotal</span><strong>${{ formatCurrency(serviceSubtotal) }}</strong>
                            </div>
                            <div class="d-flex justify-content-between">
                              <span>Inclusive GST (9%)</span><span>(${{ formatCurrency(serviceGst) }})</span>
                            </div>
                          </div>
                          <div class="d-flex justify-content-between sd_sb_bt_last">
                            <strong>Total</strong><strong>${{ formatCurrency(serviceTotal) }}</strong>
                          </div>
                        </div>
                      </div>

                      <div v-if="isMobile()">
                        <div
                          v-show="phase === 'customerDetail'"
                          class="fixed_action_block"
                        >
                          <button
                            class="back__button p4a__text-base-color"
                            @click="$router.back()"
                          >
                            Exit
                          </button>
                          <button
                            v-show="phase === 'customerDetail'"
                            type="button"
                            class="btn p4a__common-btn w-100"
                            block
                            :disabled="!enableNextPhaseCustomer"
                            @click="changePhase"
                          >
                            Proceed to next step<br>进行下一步
                          </button>
                        </div>

                        <div
                          v-show="phase === 'packageDetail'"
                          class="fixed_action_block"
                        >
                          <button
                            class="back__button"
                            @click="changePhaseFromBreadcrumb('customerDetail')"
                          >
                            Back
                          </button>
                          <button
                            v-show="phase == 'packageDetail'"
                            type="button"
                            class="btn p4a__common-btn w-100"
                            block
                            :disabled="!enableNextPhaseCustomFields"
                            @click="changePhase"
                          >
                            Proceed to next step<br>进行下一步
                          </button>
                        </div>

                        <div
                          v-show="phase === 'serviceDescription'"
                          class="fixed_action_block"
                        >
                          <button
                            class="back__button"
                            @click="changePhaseFromBreadcrumb(customFieldsLength ? 'packageDetail' : 'customerDetail')"
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            class="btn p4a__common-btn w-100"
                            block
                            @click="changePhase"
                          >
                            <template v-if="serviceOrderItems.length">
                              Proceed to next step<br>进行下一步
                            </template>
                            <template v-else>
                              Skip and proceed to next step<br>跳过并进行下一步
                            </template>
                          </button>
                        </div>
                      </div>

                      <div class="package__info">
                        <div
                          v-show="phase === 'customerDetail'"
                          class="button__block"
                        >
                          <button
                            v-if="isMobile()"
                            class="back__button p4a__text-base-color"
                            @click="$router.back()"
                          >
                            Exit
                          </button>
                          <button
                            v-show="phase === 'customerDetail'"
                            type="button"
                            class="btn p4a__common-btn w-100"
                            block
                            :disabled="!enableNextPhaseCustomer"
                            @click="changePhase"
                          >
                            Proceed to next step<br>进行下一步
                          </button>
                        </div>
                        <div
                          v-show="phase == 'packageDetail'"
                          class="button__block"
                        >
                          <button
                            v-if="isMobile()"
                            class="back__button p4a__text-base-color"
                            @click="changePhaseFromBreadcrumb('customerDetail')"
                          >
                            Back
                          </button>
                          <button
                            v-show="phase == 'packageDetail'"
                            type="button"
                            class="btn p4a__common-btn w-100"
                            block
                            :disabled="!enableNextPhaseCustomFields"
                            @click="changePhase"
                          >
                            Proceed to next step<br>进行下一步
                          </button>
                        </div>

                        <div
                          v-show="phase === 'serviceDescription'"
                          class="button__block"
                        >
                          <button
                            v-if="isMobile()"
                            class="back__button p4a__text-base-color"
                            @click="changePhaseFromBreadcrumb(customFieldsLength ? 'packageDetail' : 'customerDetail')"
                          >
                            Back
                          </button>
                          <button
                            type="button"
                            class="btn p4a__common-btn w-100"
                            block
                            @click="changePhase"
                          >
                            <template v-if="serviceOrderItems.length">
                              Proceed to next step<br>进行下一步
                            </template>
                            <template v-else>
                              Skip and proceed to next step<br>跳过并进行下一步
                            </template>
                          </button>
                        </div>

                        <div v-show="phase === 'summaryPhase' && !serviceOrderItems.length">
                          <validation-provider
                            #default="{ errors }"
                            name="Agreement"
                            vid="h-agreement"
                            rules="required"
                          >
                            <b-form-checkbox
                              v-model="secondAgree"
                              value="accepted"
                              unchecked-value=""
                              class="p4a__checkbox-bg"
                              :state="(errors.length > 0) ? false : null"
                            >
                              <span class="p4a__summary-checkbox-text">
                                By registering, you agree to follow the PDPA agreement. (If you do not agree, we cannot collect your personal data and accept your registration)
                                <br>
                                我已阅读并同意遵守上述个人资料保护令协议。（若您不同意，我们将无法收集您的个人资料，并接受您的注册）
                              </span>
                            </b-form-checkbox>
                          </validation-provider>
                          <div
                            v-if="isMobile()"
                            class="fixed_action_block"
                          >
                            <button
                              class="back__button p4a__text-base-color"
                              @click="changePhaseFromBreadcrumb('serviceDescription')"
                            >
                              Back
                            </button>

                            <button
                              type="button"
                              class="btn p4a__common-btn w-100"
                              block
                              :disabled="invalid"
                              @click="submitFullForm"
                            >
                              Submit Registration Form<br>提交表格
                            </button>
                          </div>
                          <div class="button__block">
                            <button
                              v-if="isMobile()"
                              class="back__button p4a__text-base-color"
                              @click="changePhaseFromBreadcrumb('serviceDescription')"
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              class="btn p4a__common-btn w-100"
                              block
                              :disabled="invalid"
                              @click="submitFullForm"
                            >
                              Submit Registration Form<br>提交表格
                            </button>
                          </div>
                        </div>

                      </div>
                    </b-card>

                    <b-card
                      v-if="phase === 'summaryPhase' && serviceOrderItems.length > 0"
                      class="mt-2 payment_method_block_st4"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Agreement"
                        vid="h-agreement-sr"
                        rules="required"
                      >
                        <b-form-checkbox
                          v-model="secondAgree"
                          value="accepted"
                          unchecked-value=""
                          class="p4a__checkbox-bg"
                          :state="(errors.length > 0) ? false : null"
                        >
                          <span class="p4a__summary-checkbox-text">
                            By proceeding, you agree to follow the PDPA agreement. (If you do not agree, we cannot collect your personal data and accept your registration)
                            <br>
                            我已阅读并同意遵循上述内容。(如果您不同意，我们无法收集您的个人资料和接受您的报名)
                          </span>
                        </b-form-checkbox>
                      </validation-provider>

                      <hr class="p4a__hr-base-border">
                      <p class="p4a__text-bold-gray mb-50">
                        To make payment, select your preferred payment mode:
                      </p>
                      <div class="payment_button_group_stv">
                        <b-button
                          v-for="mode in paymentModes"
                          :key="mode.key"
                          block
                          class="p4a__payment-mode-btn"
                          :disabled="secondAgree !== 'accepted'"
                          @click="selectPaymentMode(mode.key)"
                        >
                          <template v-if="mode.key === 'card'">
                            <b-img
                              :src="visaCardIcon"
                              alt="Visa"
                              height="20"
                              class="mr-50"
                            />
                            <b-img
                              :src="masterCardIcon"
                              alt="Mastercard"
                              height="20"
                              class="mr-1"
                            />
                          </template>
                          <b-img
                            v-else-if="mode.key === 'grabpay'"
                            :src="grabPayIcon"
                            alt="GrabPay"
                            height="20"
                            class="mr-1"
                          />
                          <b-img
                            v-else-if="mode.key === 'paynow'"
                            :src="payNowIcon"
                            alt="PayNow"
                            height="20"
                            class="mr-1"
                          />
                          <b-img
                            v-else-if="mode.key === 'googlepay'"
                            :src="googlePayIcon"
                            alt="GooglePay"
                            height="20"
                            class="mr-1"
                          />
                          <span>{{ mode.label }}</span>
                        </b-button>
                      </div>

                      <div
                        v-if="isMobile()"
                        class="fixed_action_block"
                      >
                        <button
                          class="back__button p4a__text-base-color"
                          @click="changePhaseFromBreadcrumb('serviceDescription')"
                        >
                          Back
                        </button>
                      </div>
                    </b-card>
                  </vue-sticky-sidebar>
                </b-col>
              </b-row>
            </b-container>
          </validation-observer>
        </b-form>
      </div>

      <b-modal
        id="modal-1"
        size="lg"
        title=""
        centered
        no-stacking
        hide-footer
        header-class="front-modal"
      >
        <h3>Confirmation Required</h3>
        <p v-if="isPhoneHidden">
          We will now send a one time password to <strong>applicant’s email {{ customerEmail }}</strong> to confirm your registration.<br>
          为了确认成功报名注册，我们将会寄出一次性密码至<strong>申请人邮箱 {{ customerEmail }}</strong>
        </p>
        <p v-else>
          We will now send a one time password to <strong>applicant’s mobile {{ customerContact }}</strong> to confirm your registration.<br>
          为了确认成功报名注册，我们将会寄出一次性密码至<strong>申请人邮箱 {{ customerContact }}</strong>
        </p>
        <b-button
          variant="primary"
          @click="sendConfirmationOTP('customer')"
        >
          Send OTP to {{ customerEmail ? customerEmail : customerContact }} 一次性密码
        </b-button>
        <div class="clear" />
        <b-button
          v-b-modal.modal-2
          variant="link"
        >
          Use agent’s contact instead
        </b-button>
      </b-modal>

      <!-- modal -->
      <b-modal
        id="modal-2"
        size="lg"
        title=""
        centered
        no-stacking
        hide-footer
        header-class="front-modal"
      >
        <h3>Confirmation Required</h3>
        <p>We will now send a one time password to the <strong>agent’s mobile below</strong> to confirm your registration.<br>为了确认成功报名注册，我们将会寄出一次性密码至以下所填写的代理人号码。</p>
        <b-row>
          <b-col md="6">
            <b-form-input
              id="h-agent-phone-number"
              v-model="agentContact"
              placeholder="+65 8 Digits Phone Number"
            />
            <small
              v-if="agentContactValidation"
              class="text-danger"
            >
              {{ agentContactError }}
            </small>
          </b-col>
        </b-row>
        <b-button
          v-b-modal.modal-3
          variant="primary"
          :disabled="agentContact.length !== 8"
          @click="sendConfirmationOTP('agent')"
        >
          Send OTP to {{ agentContact }} 一次性密码
        </b-button>
        <div class="clear" />
        <b-button
          v-b-modal.modal-1
          variant="link"
        >
          Use applicant’s mobile number instead
        </b-button>
      </b-modal>

      <!-- modal -->
      <b-modal
        id="modal-3"
        size="lg"
        title=""
        centered
        no-stacking
        hide-footer
        header-class="front-modal"
      >
        <h3>One Time Password</h3>
        <p>Enter your one time password send to {{ otpSentToPhone }}. 请输入寄去 {{ otpSentToPhone }}的一次性密码。</p>
        <b-row>
          <b-col md="6">
            <b-form-input
              id="h-phone-number"
              v-model="enteredOTP"
              placeholder="Enter OTP"
            />

            <small
              v-if="enteredOTPValidation"
              class="text-danger"
            >
              {{ enteredOTPError }}
            </small>
          </b-col>
          <b-col
            md="12"
            class="otp_sending"
          >
            <p v-if="timeCountDown > 0">
              Resend OTP in {{ timeCountDown }} seconds
            </p>
            <p
              v-else
              class="clickableText"
              @click="resendConfirmationOTP"
            >
              Resend OTP
            </p>
          </b-col>
        </b-row>

        <b-button
          :disabled="enteredOTP.length !== 6"
          variant="primary"
          @click="submitFullForm"
        >
          Submit 提交
        </b-button>
      </b-modal>

      <!-- modal -->
      <b-modal
        id="activity-payment-success-modal"
        title=""
        centered
        no-stacking
        no-close-on-backdrop
        hide-footer
        header-class="front-modal"
      >
        <div class="text-center stv_modal_content">
          <img
            :src="successIconStv"
            alt="Success"
            width="80"
            height="80"
          >
          <h3 class="mt-1">
            Form submitted and payment completed successfully
          </h3>
          <p>
            Order no.: <strong>{{ successOrderNo }}</strong>
          </p>
          <p>
            The service form is submitted for Duty Officer to review. Your tax invoice will be sent to your email <strong>{{ customerEmail || customerContact }}</strong>.
          </p>
          <b-button
            variant="primary"
            class="p4a__success-swal-btn"
            @click="closePaymentSuccessModal"
          >
            Got it
          </b-button>
        </div>
        <div class="d-flex align-items-center justify-content-center stvModal_footer">
          <span>Tax Invoice number: <strong>{{ successTaxInvoiceNo }}</strong></span>
          <button
            type="button"
            class="btn btn-link p-0 ml-50"
            @click="copyTaxInvoiceNumber"
          >
            <feather-icon
              icon="CopyIcon"
              size="16"
            />
          </button>
        </div>
      </b-modal>

      <b-modal
        id="activity-payment-failed-modal"
        size="lg"
        title=""
        centered
        no-stacking
        no-close-on-backdrop
        hide-footer
        header-class="front-modal"
      >
        <div class="text-center">
          <feather-icon
            icon="XCircleIcon"
            size="50"
            class="mb-1 text-danger"
          />
          <h3 class="mt-1">
            Payment failed
          </h3>
          <p>
            {{ paymentErrorMessage || 'Payment was unsuccessful. Please select another payment mode or try again.' }}
          </p>
          <b-button
            variant="primary"
            class="p4a__success-swal-btn"
            @click="$root.$emit('bv::hide::modal', 'activity-payment-failed-modal', '')"
          >
            Try again
          </b-button>
        </div>
      </b-modal>

      <footer />
    </div>

    <not-found-error
      v-if="pageNotFound"
    />

  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
/* eslint-disable global-require */
import vueStickySidebar from 'vue-sticky-sidebar'
import {
  BRow, BContainer, BCol, BBreadcrumb, BBreadcrumbItem, BInputGroup,
  BCard, BCardText, BFormGroup, BFormInput, BButton, BFormTextarea, BListGroup, BListGroupItem,
  BInputGroupAppend, BFormRadio, BAlert, BForm, BFormCheckbox, BModal, BImg, BSpinner,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import '@google-pay/button-element'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import flatPickr from 'vue-flatpickr-component'
import { required } from '@validations'
import '@core/scss/vue/libs/vue-flatpicker.scss'

import NotFoundError from '../pages/error/NotFoundError.vue'
import Loader from './Loader.vue'

export default {
  components: {
    BForm,
    BRow,
    BContainer,
    BCol,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardText,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BButton,
    BFormTextarea,
    BInputGroupAppend,
    BFormRadio,
    BFormCheckbox,
    BListGroup,
    BListGroupItem,
    BModal,
    BImg,
    BSpinner,
    // BFormRadioGroup,
    BFormCheckboxGroup,

    'vue-sticky-sidebar': vueStickySidebar,
    BAlert,
    Cleave,
    flatPickr,
    Loader,
    NotFoundError,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      limitPosition: 195,
      scrolled: false,
      showCustomerCrossIcon: false,
      lastPosition: 0,
      bottomActionBlock: 0,
      phase: 'customerDetail',
      activity: {},
      pack: {},
      timeSlots: [],
      enabledDates: [],
      start: '',
      startValidation: false,
      startError: 'Valid date is required',
      startTime: '',
      startTimeValidation: false,
      startTimeError: 'Valid time is required',
      customerName: '',
      customerNameValidation: false,
      customerNameError: 'Valid name is required',
      customerNRIC: '',
      customerCountryCode: '+65',
      customerContact: '',
      customerContactValidation: false,
      customerContactError: 'The Mobile Number field is required',
      customerEmail: '',
      customerEmailValidation: false,
      customerEmailError: 'Valid email is required',
      agentContactError: 'Valid mobile is required',
      agentContactValidation: false,
      remarks: '',
      title: '',
      agentName: '',
      agentCode: '',
      agentContact: '',
      otpSentToPhone: '',
      enteredOTP: '',
      enteredOTPError: 'Valid otp is required',
      enteredOTPValidation: false,
      customFields: [],
      timeSlotDuration: '',
      secondAgree: '',
      existingBookingWarning: false,
      pageNotFound: false,
      enableNextPhaseCustomer: false,
      enableNextPhaseCustomFields: false,
      timeCountDown: 0,
      hasAnotherBooking: false,
      logoImg: require('@/assets/images/frontend/logo-orange-yellow-svg.svg'),
      logoMobileImg: require('@/assets/images/frontend/logo-orange-yellow-mobile.svg'),
      modalIcon: require('@/assets/images/frontend/modal_icon.svg'),
      isPhoneHidden: false,
      isEmailHidden: true,
      customFieldsLength: false,
      // Temporary UI switch to hide the "Add-on services 附加服务" step without touching its code — flip to false to bring it back
      hideAddOnServicesStep: true,
      verifiedType: '',
      searchInput: '',
      customer: {},
      customerID: '',
      agentCustomers: [],
      foundCustomers: [],
      searchResultNotFound: false,
      showSearchResult: false,
      agent: {},
      existingCustomer: false,
      appointmentSource: 'web',
      customerContactType: 'phone',
      flatPickrConfig: {
        wrap: true, enableTime: false, dateFormat: 'd/m/Y', enable: [], disable: [], minDate: 'today', disableMobile: true,
      },
      options: {
        prefix: {
          numericOnly: true,
          prefix: '+65',
          blocks: [3, 8],
        },
      },
      requiredOptions: [
        { text: 'Yes', value: 'yes' },
        { text: 'No', value: 'no' },
      ],

      sdFields: [],
      sdServiceDescription: [],
      otherRequestsSR: '',
      selectedPaymentMode: '',
      paymentModes: [
        { key: 'card', label: 'Credit Card' },
        { key: 'grabpay', label: 'GrabPay' },
        { key: 'paynow', label: 'PayNow' },
        { key: 'googlepay', label: 'GooglePay' },
      ],
      makePaymentStep: 'form',
      cardholderName: '',
      cardNumber: '',
      cardExpiry: '',
      cardCvv: '',
      cardNameValidation: false,
      cardNumberValidation: false,
      cardExpiryValidation: false,
      cardCvvValidation: false,
      cleaveOptions: {
        creditCard: { creditCard: true },
        date: {
          date: true, delimiter: '/', datePattern: ['m', 'y'],
        },
        cardCvv: { blocks: [3], numericOnly: true },
      },
      couponCode: '',
      couponState: 'idle',
      couponError: '',
      appliedCoupon: null,
      paymentProcessing: false,
      paymentErrorMessage: '',
      pendingPaymentId: null,
      paymentPollTimer: null,
      paymentPollCount: 0,
      awaitingPaymentConfirmation: false,
      payNowQRImage: null,
      payNowTimeCountDown: 300,
      successOrderNo: '',
      successTaxInvoiceNo: '',
      paymentRequest: {
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [
          {
            type: 'CARD',
            parameters: {
              allowedAuthMethods: ['PAN_ONLY'],
              allowedCardNetworks: ['AMEX', 'VISA', 'MASTERCARD'],
            },
            tokenizationSpecification: {
              type: 'PAYMENT_GATEWAY',
              parameters: {
                gateway: 'omise',
                gatewayMerchantId: '',
              },
            },
          },
        ],
        merchantInfo: {
          merchantId: '',
          merchantName: '',
        },
        transactionInfo: {
          totalPriceStatus: 'FINAL',
          totalPriceLabel: 'Total',
          totalPrice: '0.00',
          currencyCode: 'SGD',
          countryCode: 'SG',
        },
      },
      successIconImg: require('@/assets/images/frontend/success_icon.svg'),
      successIconStv: require('@/assets/images/frontend/success_icon2.svg'),
      visaCardIcon: require('@/assets/images/frontend/p4b/payment-logo/visa.png'),
      paymentCardIcon: require('@/assets/images/frontend/p4b/payment-logo/paymentGroupIcon.png'),
      masterCardIcon: require('@/assets/images/frontend/p4b/payment-logo/mastercard.png'),
      grabPayIcon: require('@/assets/images/frontend/p4b/payment-logo/grab-pay.png'),
      payNowIcon: require('@/assets/images/frontend/p4b/payment-logo/pay-now.png'),
      googlePayIcon: require('@/assets/images/frontend/p4b/payment-logo/google-pay.png'),

      required,
    }
  },
  computed: {
    showNotificationWarning() {
      const cutoffDate = new Date(2026, 6, 1)
      const today = new Date()
      return today < cutoffDate
    },
    // Generic, type-aware order-line builder over whatever the resolved ServiceDescriptionSet
    // contains (mirrors getOrderSummaryItems in ServiceBookingNew.vue and the backend's
    // helpers/retail-order-payment.js) - no longer assumes a fixed Offerings/Burning
    // Cage/Rental-of-Premises shape, so any field type/count in the set prices correctly.
    // Each line prefers the tagged Catalog Product's real price (tagProductPrice, embedded
    // server-side by ServiceDescriptionSetController's attachTagProductPrices()), falling
    // back to parsing a "$xx" amount out of the label for legacy/untagged options.
    serviceOrderItems() {
      const lines = []
      this.sdFields.forEach((opt, key) => {
        if (opt.showInFrontend !== 'yes') return
        const desc = this.sdServiceDescription[key]
        if (!desc) return
        if (opt.type === 'multi-select') {
          (desc.value || []).forEach(val => {
            const optn = (opt.extraOptions || []).find(o => o.key === val)
            const label = optn ? optn.value : val
            lines.push({
              key, label, price: this.linePrice(label, optn ? optn.tagProductPrice : null), qty: 1,
            })
          })
        } else if (opt.type === 'single-select') {
          if ((desc.value || []).includes('yes')) {
            lines.push({
              key, label: opt.label, price: this.linePrice(opt.label, opt.tagProductPrice), qty: 1,
            })
          }
        } else if (opt.type === 'dropdown') {
          if (desc.value) {
            const optn = (opt.extraOptions || []).find(o => o.key === desc.value)
            const label = optn ? optn.value : desc.value
            lines.push({
              key, label, price: this.linePrice(label, optn ? optn.tagProductPrice : null), qty: 1,
            })
          }
        } else if (opt.type === 'increment') {
          if (Number(desc.value) > 0) {
            lines.push({
              key, label: opt.baseLabel || opt.label, price: this.linePrice(opt.label, opt.tagProductPrice), qty: desc.value,
            })
          }
        }
      })
      return lines
    },
    serviceSubtotal() {
      return this.serviceOrderItems.reduce((sum, item) => sum + (item.price * item.qty), 0)
    },
    serviceGst() {
      return (this.serviceSubtotal * 9) / 109
    },
    serviceTotal() {
      const discount = this.appliedCoupon ? this.appliedCoupon.discountAmount : 0
      return this.serviceSubtotal - discount
    },
    payNowTimeRemaining() {
      const minutes = Math.floor(this.payNowTimeCountDown / 60)
      const seconds = this.payNowTimeCountDown % 60
      return `${minutes}min:${seconds < 10 ? '0' : ''}${seconds}s`
    },
    googlePayRequest() {
      return {
        ...this.paymentRequest,
        transactionInfo: {
          ...this.paymentRequest.transactionInfo,
          totalPrice: this.serviceTotal.toFixed(2),
        },
      }
    },
  },
  beforeMount() {
    this.$http.get(`front-end/activity/${this.$route.params.id}/show`)
      .then(response => {
        this.activity = response.data.data || {}
        // this.start = this.dateFormat(this.event.startDate)
        const enable = []
        this.activity.timeSlots.forEach(element => {
          const timeObj = {}
          timeObj.from = this.dateFormat(element.startDate)
          timeObj.to = this.dateFormat(element.endDate)

          enable.push(timeObj)
        })

        this.flatPickrConfig.enable = enable

        // let disable = []

        // if (response.data.blockOutDate) {
        //   disable = [
        //     {
        //       from: this.dateFormat(response.data.blockOutDate.startDate),
        //       to: this.dateFormat(response.data.blockOutDate.endDate),
        //     },
        //   ]
        // }

        // this.flatPickrConfig.disable = disable

        let fieldCount = 0
        if (this.activity.customFields.length) {
          const newArray = []
          this.activity.customFields.forEach(arrayItem => {
            const newObj = {}
            if (!['file', 'title-and-text'].includes(arrayItem.type)) {
              // eslint-disable-next-line no-plusplus
              fieldCount++
            }
            newObj.key = arrayItem.label
            newObj.field = arrayItem.type
            newObj.required = arrayItem.required
            if (arrayItem.type === 'multi-select' || arrayItem.type === 'single-select') {
              newObj.value = []
            } else {
              newObj.value = ''
            }
            newArray.push(newObj)
          })

          this.customFields = newArray
        }

        if (fieldCount > 0 && !this.hideAddOnServicesStep) {
          this.customFieldsLength = true
        }

        this.pageNotFound = false
        this.enableNextPhaseCustomFieldsDetail()
      })
      .catch(error => {
        this.pageNotFound = true
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    this.$http.get(`front-end/service-description-sets/respond-with/by-appointment-type/${this.$route.params.id}`)
      .then(response => {
        const items = (response.data.data && response.data.data.items) || []
        this.sdFields = items
        this.sdServiceDescription = items.map(field => {
          const value = {
            key: field.label, type: field.type, id: field.id, parent: field.parent,
          }
          if (field.type === 'multi-select' || field.type === 'single-select') {
            value.value = []
          } else if (field.type === 'title-and-text') {
            value.value = ''
            value.text = field.description
          } else if (field.type === 'increment') {
            value.value = +field.minQuantity || 0
          } else {
            value.value = ''
          }
          return value
        })
      })
      .catch(() => {})

    this.$http.get('front-end/service-bookings/payment/config')
      .then(response => {
        // eslint-disable-next-line no-undef
        Omise.setPublicKey(response.data.omisePublicKey)
        this.paymentRequest.allowedPaymentMethods[0].tokenizationSpecification.parameters.gatewayMerchantId = response.data.omisePublicKey
        this.paymentRequest.merchantInfo.merchantId = response.data.gPayMerchantID
        this.paymentRequest.merchantInfo.merchantName = response.data.gPayMerchantName
      })
      .catch(() => {})

    const resumePendingPaymentId = localStorage.getItem('activityPaymentPendingId')
    if (resumePendingPaymentId) {
      localStorage.removeItem('activityPaymentPendingId')
      this.pendingPaymentId = resumePendingPaymentId
      this.phase = 'makePayment'
      this.makePaymentStep = 'form'
      this.startPollingPaymentStatus()
    }
  },
  created() {
    window.addEventListener('scroll', this.stepperHandleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.stepperHandleScroll)
    if (this.paymentPollTimer) {
      clearTimeout(this.paymentPollTimer)
    }
  },
  mounted() {
    this.calcPosOfBox()
    this.verifiedType = localStorage.getItem('verifiedCustomerType')
    if (this.verifiedType === 'agent') {
      this.agent = JSON.parse(localStorage.getItem('bookingAgent'))
      this.agentCustomers = JSON.parse(localStorage.getItem('agentCustomers'))
      this.agentName = this.agent.name
      this.agentCode = this.agent.code
      this.agentContact = this.agent.personalContact
      const src = localStorage.getItem('appointmentSource')
      if (src && src === 'agent-app') {
        this.appointmentSource = 'agent-app'
      } else {
        this.appointmentSource = 'agent'
      }
    } else {
      this.customer = localStorage.getItem('verifiedCustomer') ? JSON.parse(localStorage.getItem('verifiedCustomer')) : {}
      this.customerName = this.customer.name || ''
      this.customerNRIC = this.customer.nric || ''
      this.customerID = this.customer._id || ''
      const contactType = localStorage.getItem('customerVerifiedContactType')
      const contact = localStorage.getItem('customerVerifiedContact')
      if (contactType === 'phone') {
        this.customerEmail = this.customer.perEmail || ''
        const parsedContact = this.parsePhoneNumber(contact)
        this.customerCountryCode = parsedContact.countryCode
        this.customerContact = parsedContact.number

        if (this.customerContact.length) {
          this.customerContactValidation = false
          this.enableNextPhaseCustomerDetail()
        } else {
          this.customerContactValidation = true
          this.enableNextPhaseCustomer = false
        }
      } else {
        this.customerContactType = 'email'
        const parsedContact = this.parsePhoneNumber(this.customer.perContact || '')
        this.customerCountryCode = parsedContact.countryCode
        this.customerContact = parsedContact.number
        this.customerEmail = contact
        this.isPhoneHidden = true
        this.isEmailHidden = false
        this.enableNextPhaseCustomerDetail()
      }
      // this.checkForCustomerSchedule()
    }
  },

  methods: {
    async calcPosOfBox() {
      await this.$nextTick()
      if (this.$refs.sticky_sidebar) {
        this.bottomActionBlock = this.$refs.sticky_sidebar.offsetTop
      }
      this.limitPosition = this.$refs.stepper_block.getBoundingClientRect().y
    },
    submitSearchInput() {
      // this.searchResultNotFound = false
      // this.showSearchResult = false
      // this.foundCustomers = []
      const found = this.agentCustomers.filter(item => item.name.toLowerCase().includes(this.searchInput.toLowerCase()))
      if (found && found.length) {
        this.searchResultNotFound = false
        this.showSearchResult = true
        this.foundCustomers = found
      } else {
        // if (this.searchResultNotFound === true) {
        //   this.searchResultNotFound = false
        // } else {
        //   this.searchResultNotFound = true
        // }
        this.searchResultNotFound = true
        this.showSearchResult = false
        this.foundCustomers = []
        this.customerName = this.searchInput
        this.customerID = ''
        this.enableNextPhaseCustomerDetail()
      }
    },
    resetSearchResult() {
      setTimeout(() => {
        this.searchResultNotFound = false
        this.showSearchResult = false
      }, 500)
    },

    clearSearchInput() {
      this.searchInput = ''
      this.customerName = ''
      this.customerCountryCode = '+65'
      this.customerContact = ''
      this.customerNRIC = ''
      this.customerEmail = ''
      this.customerID = ''
      this.existingCustomer = false
      this.showCustomerCrossIcon = false
      this.searchResultNotFound = false
      this.showSearchResult = false
    },

    addSearchInputItem(customer) {
      if (customer.perContact) {
        this.existingCustomer = true
      }
      this.showCustomerCrossIcon = true
      this.customerID = customer._id
      this.searchInput = customer.name
      this.customerName = customer.name || ''
      const parsedContact = this.parsePhoneNumber(customer.perContact || '')
      this.customerCountryCode = parsedContact.countryCode
      this.customerContact = parsedContact.number
      this.customerNRIC = customer.nric
      this.customerEmail = customer.perEmail || ''
      this.foundCustomers = []
      this.showSearchResult = false
      this.searchResultNotFound = false
      this.enableNextPhaseCustomerDetail()
      this.checkForCustomerSchedule()
    },
    async handleFocusOut() {
      await this.$nextTick()
      this.showSearchResult = false
      this.searchResultNotFound = false
    },
    stepperHandleScroll() {
      if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
        this.scrolled = true
        document.body.style.paddingTop = '60px'
      }
      if (this.limitPosition > window.scrollY && this.lastPosition > window.scrollY) {
        this.scrolled = false
        document.body.style.paddingTop = '0px'
      }

      if (this.lastPosition + window.outerHeight > this.bottomActionBlock + 100) {
        document.body.classList.add('hideStickyBar')
      } else {
        document.body.classList.remove('hideStickyBar')
      }
      this.lastPosition = window.scrollY
    },
    hideModal() {
      this.$root.$emit('bv::hide::modal', 'modal-5', '')
    },
    getTimeFromDB() {
      if (this.start) {
        this.$http.post('front-end/activity/bookings/date-and-time-availability', { date: this.start, activity: this.$route.params.id })
          .then(response => {
            this.timeSlots = response.data.hours
            this.timeSlotDuration = response.data.timeSlotDuration
            if (!this.timeSlots.length) {
              this.startTimeError = 'No Time Slot Available for This Date'
              this.startTimeValidation = true
            }
          })
          .catch(error => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
      }
    },

    checkForCustomerSchedule() {
      if (this.startTime && (this.customerContact || this.validateEmail(this.customerEmail))) {
        let customer = ''
        if (this.validateEmail(this.customerEmail)) {
          customer = this.customerEmail
        } else {
          customer = this.customerCountryCode + this.customerContact
        }
        this.$http
          .post('front-end/bookings/customer-schedule-availability', { date: this.start, time: this.startTime, customer })
          .then(response => {
            if (response.data.exists === true) {
              this.existingBookingWarning = true
              this.hasAnotherBooking = true
            } else {
              this.existingBookingWarning = false
              this.hasAnotherBooking = false
            }
          })
          .catch(() => {
            // this.existingBookingWarning = true
          })
      }
    },

    changePhase() {
      if (this.phase === 'customerDetail') {
        if (this.customFieldsLength) {
          this.phase = 'packageDetail'
        } else {
          this.phase = 'serviceDescription'
        }
      } else if (this.phase === 'packageDetail') {
        this.phase = 'serviceDescription'
      } else if (this.phase === 'serviceDescription') {
        this.phase = 'summaryPhase'
      }

      window.scrollTo(0, 0)
      this.calcPosOfBox()
    },

    getActivePhase(phase) {
      if (phase === 'customerDetail') {
        if (this.phase === 'customerDetail' || this.phase === 'packageDetail' || this.phase === 'serviceDescription' || this.phase === 'summaryPhase' || this.phase === 'makePayment') {
          return true
        }
      } else if (phase === 'packageDetail') {
        if (this.phase === 'packageDetail' || this.phase === 'serviceDescription' || this.phase === 'summaryPhase' || this.phase === 'makePayment') {
          return true
        }
      } else if (phase === 'serviceDescription') {
        if (this.phase === 'serviceDescription' || this.phase === 'summaryPhase' || this.phase === 'makePayment') {
          return true
        }
      } else if (phase === 'summaryPhase') {
        if (this.phase === 'summaryPhase' || this.phase === 'makePayment') {
          return true
        }
      } else if (phase === 'makePayment') {
        if (this.phase === 'makePayment') {
          return true
        }
      }

      return false
    },

    isParentGroupTitle(opt, fields) {
      return opt.type === 'title-and-text' && !opt.parent && fields.some(field => field.parent === opt.id)
    },

    // Groups sdFields into parent/child trees (a title-and-text field followed by the
    // fields nested under it) so the template can render whatever sections the resolved
    // ServiceDescriptionSet actually defines, in order, instead of assuming a fixed
    // Offerings/Burning-Cage/Rental-of-Premises layout. Mirrors ServiceBookingNew.vue's
    // serviceDescriptionGroupsFor.
    serviceDescriptionGroupsFor(fields) {
      const nodeMap = new Map()
      fields.forEach((field, key) => {
        nodeMap.set(field.id, { opt: field, key, children: [] })
      })

      const roots = []
      fields.forEach(field => {
        const node = nodeMap.get(field.id)
        const parentNode = field.parent && nodeMap.get(field.parent)
        if (parentNode) {
          parentNode.children.push(node)
        } else {
          roots.push(node)
        }
      })

      const flattenNode = (node, out) => {
        out.push({ opt: node.opt, key: node.key })
        node.children.forEach(child => flattenNode(child, out))
      }

      return roots.map(root => {
        const out = []
        flattenNode(root, out)
        return out
      })
    },

    incrementSdField(key) {
      const opt = this.sdFields[key]
      const desc = this.sdServiceDescription[key]
      const max = opt.maxQuantity !== undefined && opt.maxQuantity !== '' ? +opt.maxQuantity : Infinity
      if (desc.value + (+opt.increments || 1) <= max) desc.value += (+opt.increments || 1)
    },
    decrementSdField(key) {
      const opt = this.sdFields[key]
      const desc = this.sdServiceDescription[key]
      const min = opt.minQuantity !== undefined && opt.minQuantity !== '' ? +opt.minQuantity : 0
      if (desc.value - (+opt.increments || 1) >= min) desc.value -= (+opt.increments || 1)
    },
    toggleSdMultiSelect(key, optKey) {
      const desc = this.sdServiceDescription[key]
      if (desc.value.includes(optKey)) {
        desc.value = desc.value.filter(val => val !== optKey)
      } else {
        desc.value = [...desc.value, optKey]
      }
    },
    toggleSdSingleSelect(key) {
      const desc = this.sdServiceDescription[key]
      desc.value = desc.value.includes('yes') ? [] : ['yes']
    },
    removeServiceOrderItem(item) {
      const opt = this.sdFields[item.key]
      const desc = this.sdServiceDescription[item.key]
      if (!opt || !desc) return
      if (opt.type === 'increment') {
        desc.value = +opt.minQuantity || 0
      } else if (opt.type === 'multi-select') {
        desc.value = desc.value.filter(val => {
          const optn = (opt.extraOptions || []).find(o => o.key === val)
          return (optn ? optn.value : val) !== item.label
        })
      } else if (opt.type === 'single-select' || opt.type === 'dropdown') {
        desc.value = opt.type === 'single-select' ? [] : ''
      }
    },
    formatCurrency(value) {
      return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    extractPrice(label) {
      const match = String(label).match(/S?\$\s?([\d,]+(?:\.\d+)?)/)
      return match ? parseFloat(match[1].replace(/,/g, '')) : 0
    },
    // Prefers the tagged Catalog Product's real price and falls back to parsing a "$xx"
    // amount out of the label for legacy/untagged options - mirrors resolveLinePrices()
    // in the backend's retail-order-payment helper, the actual source of truth for what
    // gets charged.
    linePrice(label, tagProductPrice) {
      if (tagProductPrice !== undefined && tagProductPrice !== null) return tagProductPrice
      return this.extractPrice(label)
    },
    selectPaymentMode(key) {
      this.selectedPaymentMode = key
      this.paymentErrorMessage = ''
      this.makePaymentStep = 'form'
      this.phase = 'makePayment'
      window.scrollTo(0, 0)
      this.calcPosOfBox()
    },
    validateCardForm() {
      this.cardNameValidation = !this.cardholderName.trim()

      const trimmedCardNumber = this.cardNumber.trim().replace(/\s/g, '')
      this.cardNumberValidation = trimmedCardNumber.length !== 16

      const splitExpiry = this.cardExpiry.split('/')
      this.cardExpiryValidation = splitExpiry.length !== 2 || splitExpiry[0].length !== 2 || splitExpiry[1].length !== 2

      this.cardCvvValidation = this.cardCvv.length !== 3

      return !this.cardNameValidation && !this.cardNumberValidation && !this.cardExpiryValidation && !this.cardCvvValidation
    },
    confirmAndPay() {
      if (this.selectedPaymentMode === 'card' && !this.validateCardForm()) {
        return
      }

      this.paymentErrorMessage = ''
      this.paymentProcessing = true

      if (this.selectedPaymentMode === 'card') {
        this.chargeCard()
      } else {
        this.initiateAsyncPayment()
      }
    },
    chargeCard() {
      const trimmedCardNumber = this.cardNumber.trim().replace(/\s/g, '')
      const splitExpiry = this.cardExpiry.split('/')
      const tokenParameters = {
        name: this.cardholderName,
        number: trimmedCardNumber,
        expiration_month: Number(splitExpiry[0]),
        expiration_year: Number(splitExpiry[1]),
        security_code: this.cardCvv,
      }

      // eslint-disable-next-line no-undef
      Omise.createToken('card', tokenParameters, (statusCode, response) => {
        if (statusCode !== 200) {
          this.paymentProcessing = false
          this.paymentErrorMessage = response.message || 'Invalid card details. Please check and try again.'
          return
        }

        this.chargeWithOmiseToken(response.id, trimmedCardNumber.slice(-4))
      })
    },
    onGooglePayLoadPaymentData(event) {
      const { token } = event.detail.paymentMethodData.tokenizationData
      this.paymentErrorMessage = ''
      this.paymentProcessing = true

      const tokenParameters = { method: 'googlepay', data: token }
      // eslint-disable-next-line no-undef
      Omise.createToken('tokenization', tokenParameters, (statusCode, response) => {
        if (statusCode !== 200) {
          this.paymentProcessing = false
          this.paymentErrorMessage = response.message || 'Google Pay payment failed. Please try again.'
          return
        }

        this.chargeWithOmiseToken(response.id, '')
      })
    },
    onGooglePayError() {
      this.paymentProcessing = false
      this.paymentErrorMessage = 'Google Pay payment failed. Please try again.'
    },
    chargeWithOmiseToken(cardToken, cardNumberLast4) {
      const formData = this.buildBookingFormData()
      formData.append('cardToken', cardToken)
      formData.append('cardNumber', cardNumberLast4)
      formData.append('url', window.location.origin)

      this.$http.post('front-end/activity/bookings/pay/card', formData)
        .then(res => {
          this.paymentProcessing = false
          if (res.data.orderNos && res.data.orderNos.length) {
            this.onPaymentSuccess(res.data)
          } else if (res.data.redirectURL) {
            if (res.data.pendingPaymentId) {
              localStorage.setItem('activityPaymentPendingId', res.data.pendingPaymentId)
            }
            window.open(res.data.redirectURL, '_self')
          } else if (res.data.success || res.data.pending) {
            this.pendingPaymentId = res.data.pendingPaymentId
            this.startPollingPaymentStatus()
          } else {
            this.paymentErrorMessage = res.data.message || 'Payment failed. Please try again.'
            this.$root.$emit('bv::show::modal', 'activity-payment-failed-modal', '')
          }
        })
        .catch(error => {
          this.paymentProcessing = false
          this.paymentErrorMessage = error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE
          this.$root.$emit('bv::show::modal', 'activity-payment-failed-modal', '')
        })
    },
    initiateAsyncPayment() {
      const formData = this.buildBookingFormData()
      formData.append('paymentMode', this.selectedPaymentMode)
      formData.append('url', window.location.origin)

      this.$http.post('front-end/activity/bookings/pay/initiate', formData)
        .then(res => {
          this.paymentProcessing = false
          if (!res.data.success) {
            this.paymentErrorMessage = res.data.message || 'Unable to initiate payment.'
            this.$root.$emit('bv::show::modal', 'activity-payment-failed-modal', '')
            return
          }

          this.pendingPaymentId = res.data.pendingPaymentId

          if (this.selectedPaymentMode === 'grabpay' && res.data.redirectUrl) {
            localStorage.setItem('activityPaymentPendingId', res.data.pendingPaymentId)
            window.open(res.data.redirectUrl, '_self')
          } else if (this.selectedPaymentMode === 'paynow' && res.data.image) {
            this.payNowQRImage = res.data.image
            this.payNowTimeCountDown = 300
            this.makePaymentStep = 'paynow-qr'
            window.scrollTo(0, 0)
            this.countDownPayNowTimer()
            this.startPollingPaymentStatus(false)
          }
        })
        .catch(error => {
          this.paymentProcessing = false
          this.paymentErrorMessage = error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE
          this.$root.$emit('bv::show::modal', 'activity-payment-failed-modal', '')
        })
    },
    countDownPayNowTimer() {
      if (this.makePaymentStep !== 'paynow-qr') return
      if (this.payNowTimeCountDown > 0) {
        setTimeout(() => {
          this.payNowTimeCountDown -= 1
          this.countDownPayNowTimer()
        }, 1000)
      } else {
        this.regeneratePayNowQR()
      }
    },
    regeneratePayNowQR() {
      const formData = new FormData()
      formData.append('pendingPaymentId', this.pendingPaymentId)
      formData.append('url', window.location.origin)

      this.$http.post('front-end/activity/bookings/payment/pay-now/regenerate', formData)
        .then(res => {
          if (res.data.success) {
            this.pendingPaymentId = res.data.pendingPaymentId
            this.payNowQRImage = res.data.image
            this.payNowTimeCountDown = 300
            this.countDownPayNowTimer()
          } else {
            if (this.paymentPollTimer) clearTimeout(this.paymentPollTimer)
            this.awaitingPaymentConfirmation = false
            this.makePaymentStep = 'form'
            this.paymentErrorMessage = res.data.message || 'This QR code has expired.'
            this.$root.$emit('bv::show::modal', 'activity-payment-failed-modal', '')
          }
        })
        .catch(() => {})
    },
    startPollingPaymentStatus(showLoader = true) {
      this.awaitingPaymentConfirmation = showLoader
      this.paymentPollCount = 0
      this.checkForPaymentStatus()
      const poll = () => {
        this.paymentPollCount += 1
        const delay = this.paymentPollCount <= 5 ? 3000 : 10000
        this.paymentPollTimer = setTimeout(() => {
          this.checkForPaymentStatus()
          poll()
        }, delay)
      }
      poll()
    },
    checkForPaymentStatus() {
      this.$http.get(`front-end/activity/bookings/payment/${this.pendingPaymentId}/check/status`)
        .then(res => {
          if (res.data.success) {
            clearTimeout(this.paymentPollTimer)
            this.awaitingPaymentConfirmation = false
            this.makePaymentStep = 'form'
            this.onPaymentSuccess(res.data)
          } else if (res.data.failed) {
            clearTimeout(this.paymentPollTimer)
            this.awaitingPaymentConfirmation = false
            this.makePaymentStep = 'form'
            this.paymentErrorMessage = 'Payment failed. Please try again.'
            this.$root.$emit('bv::show::modal', 'activity-payment-failed-modal', '')
          }
          // else still pending - keep polling
        })
        .catch(() => {})
    },
    onPaymentSuccess(data) {
      this.successOrderNo = (data.orderNos || []).join(', ')
      this.successTaxInvoiceNo = data.invoiceNo || ''
      this.$root.$emit('bv::show::modal', 'activity-payment-success-modal', '')
    },
    closePaymentSuccessModal() {
      this.$root.$emit('bv::hide::modal', 'activity-payment-success-modal', '')
      this.$router.push({ name: 'appointments-front-end' })
      document.body.style.paddingTop = '0px'
    },
    copyTaxInvoiceNumber() {
      navigator.clipboard.writeText(this.successTaxInvoiceNo)
    },
    applyCoupon() {
      if (!this.couponCode || this.couponState === 'applying') return
      this.couponState = 'applying'

      const formData = new FormData()
      formData.append('couponCode', this.couponCode)
      formData.append('customerEmail', this.customerEmail)
      formData.append('orderAmount', this.serviceSubtotal)

      this.$http.post('front-end/retail-coupons/validate', formData)
        .then(response => {
          this.appliedCoupon = {
            couponId: response.data.data.couponId,
            label: response.data.data.couponTitle,
            discountAmount: response.data.data.discountAmount,
          }
          this.couponState = 'applied'
          this.couponCode = ''
        })
        .catch(error => {
          this.couponState = 'invalid'
          this.couponError = error.data.message || 'This coupon code is invalid.'
        })
    },
    removeCoupon() {
      if (!this.appliedCoupon) return

      const formData = new FormData()
      formData.append('couponId', this.appliedCoupon.couponId)
      formData.append('customerEmail', this.customerEmail)

      this.$http.post('front-end/retail-coupons/release', formData)
        .catch(() => {})
        .finally(() => {
          this.appliedCoupon = null
          this.couponState = 'idle'
        })
    },

    changePhaseFromBreadcrumb(phase) {
      this.phase = phase
      window.scrollTo(0, 0)
      this.calcPosOfBox()
    },

    validateEmail(inputText) {
      // eslint-disable-next-line no-useless-escape
      const mailFormat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (inputText && inputText.match(mailFormat)) {
        return true
      }
      return false
    },

    validateCustomerName() {
      this.customerNameValidation = false
      this.enableNextPhaseCustomerDetail()
    },

    validateCustomerContact() {
      // if (this.customerContact.length > 4 && this.customerContact.length <= 12) {
      //   if (this.customerContact.length === 12) {
      //     this.customerContactValidation = false
      //     this.enableNextPhaseCustomerDetail()
      //     this.checkForCustomerSchedule()
      //   } else {
      //     this.customerContactValidation = true
      //     this.enableNextPhaseCustomer = false
      //   }
      // } else if (this.customerContact.length === 4) {
      //   this.customerContactValidation = false
      //   this.enableNextPhaseCustomer = false
      // } else {
      //   this.customerContactValidation = true
      //   this.enableNextPhaseCustomer = false
      // }

      this.enableNextPhaseCustomerDetail()
      this.checkForCustomerSchedule()
    },

    validateCustomerEmail() {
      if (this.validateEmail(this.customerEmail)) {
        this.customerEmailValidation = false
        this.enableNextPhaseCustomerDetail()
        this.checkForCustomerSchedule()
      } else {
        this.customerEmailValidation = true
        this.enableNextPhaseCustomer = false
      }
    },

    validateStartTime() {
      if (this.startTime !== '') {
        this.startTimeValidation = false
        this.enableNextPhaseCustomerDetail()
        this.checkForCustomerSchedule()
      } else {
        this.startTimeValidation = true
        this.enableNextPhaseCustomer = false
      }
    },

    validateStartDate() {
      this.startTime = ''
      this.startTimeValidation = false
      if (this.start !== '') {
        this.startValidation = false
        this.enableNextPhaseCustomerDetail()
        this.getTimeFromDB()
      } else {
        this.startValidation = true
        this.enableNextPhaseCustomer = false
      }
    },

    enableNextPhaseCustomerDetail() {
      if (
        this.customerName.length !== 0
  && this.validateEmail(this.customerEmail)
  && (this.customerContactType !== 'phone' || this.customerContact.length !== 0)
  && this.start !== ''
  && this.startTime !== ''
      ) {
        this.enableNextPhaseCustomer = true
      } else {
        this.enableNextPhaseCustomer = false
      }
    },

    enableNextPhaseCustomFieldsDetail() {
      this.generateBookingTitle()
      this.customFields.every(obj => {
        if (!['file', 'title-and-text'].includes(obj.field)) {
          if (obj.required === 'yes' && obj.value.length === 0) {
            this.enableNextPhaseCustomFields = false
            return false
          }
        }
        this.enableNextPhaseCustomFields = true
        return true
      })
    },

    makeCheckboxToRadio(key) {
      const lastSelected = this.customFields[key].value.slice(-1)[0]
      if (lastSelected) {
        this.customFields[key].value = this.customFields[key].value.filter(code => code === lastSelected)
      }

      this.enableNextPhaseCustomFieldsDetail()
    },

    generateBookingTitle() {
      let title = ''
      this.activity.customFields.forEach((arrayItem, key) => {
        if (arrayItem.displayInCalendar === 'yes' && this.customFields[key].value !== '') {
          const val = this.customFields[key].value
          if (Array.isArray(val)) {
            val.forEach(arrVal => {
              const calVal = arrayItem.extraOptions.find(o => o.key === arrVal)
              title = `${title}${arrayItem.label} ${calVal.value} `
            })
          } else {
            // eslint-disable-next-line no-lonely-if
            if (arrayItem.extraOptions.length) {
              const calVal = arrayItem.extraOptions.find(o => o.key === val)
              if (calVal) {
                title = `${title}${arrayItem.label} ${calVal.value} `
              } else {
                title = `${title}${arrayItem.label} ${val} `
              }
            } else {
              title = `${title}${arrayItem.label} ${val} `
            }
          }
        }
      })
      this.title = title
    },

    sendConfirmationOTP(type) {
      if (type === 'agent') {
        this.otpSentToPhone = this.agentContact
      } else {
        this.otpSentToPhone = this.customerContact ? `${this.customerCountryCode}${this.customerContact}` : this.customerEmail
      }

      this.$http
        .post('front-end/bookings/send-otp', { otpSentToPhone: this.otpSentToPhone, customerName: this.customerName })
        .then(response => {
          this.timeCountDown = 60
          this.$root.$emit('bv::show::modal', 'modal-3', '')
          this.countDownTimer()
          if (response.data.alert) {
            // eslint-disable-next-line no-alert
            alert(response.data.alert)
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    resendConfirmationOTP() {
      this.$http
        .post('front-end/bookings/send-otp', { otpSentToPhone: this.otpSentToPhone, customerName: this.customerName })
        .then(response => {
          this.timeCountDown = 60
          this.countDownTimer()

          if (response.data.alert) {
            // eslint-disable-next-line no-alert
            alert(response.data.alert)
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || '',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    },

    countDownTimer() {
      if (this.timeCountDown > 0) {
        setTimeout(() => {
          this.timeCountDown -= 1
          this.countDownTimer()
        }, 1000)
      }
    },

    buildBookingFormData() {
      const formData = new FormData()

      formData.append('customerID', this.customerID)
      formData.append('customerName', this.customerName)
      formData.append('customerNRIC', this.customerNRIC)
      formData.append('customerContact', this.customerContact ? `${this.customerCountryCode}${this.customerContact}` : '')
      formData.append('customerEmail', this.customerEmail)
      formData.append('activityType', this.$route.params.id)
      formData.append('startDate', this.start)
      formData.append('startTime', this.startTime)
      formData.append('timeSlotDuration', this.timeSlotDuration)
      formData.append('remarks', this.remarks)
      formData.append('title', this.title)
      formData.append('hasAnotherBooking', this.hasAnotherBooking)
      formData.append('agentID', (this.agent && this.agent._id) ? this.agent._id : '')
      formData.append('agentName', this.agentName)
      formData.append('agentCode', this.agentCode)
      formData.append('agentContact', this.agentContact)
      formData.append('appointmentSource', this.appointmentSource)
      // formData.append('otpSentToPhone', this.otpSentToPhone)
      // formData.append('enteredOTP', this.enteredOTP)
      formData.append('customFields', JSON.stringify(this.customFields))
      formData.append('serviceDescriptionItems', JSON.stringify(this.sdServiceDescription))
      formData.append('otherRequestsSR', this.otherRequestsSR)

      return formData
    },
    submitFullForm() {
      this.$refs.frontActivityBookingCreateForm.validate().then(success => {
        if (success) {
          const formData = this.buildBookingFormData()

          this.$http.post('front-end/bookings/store/activity', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              if (response.data.data) {
                this.$swal({
                  html: `<h3 class="p4a__success-swal-title">Successfully Registered!</h3><p class="p4a__success-swal-subtitle">You will be receiving a confirmation message to be sent to ${this.customerEmail || this.customerContact} shortly.
                  您将很快收到一封确认邮件，该邮件将发送至 ${this.customerEmail || this.customerContact}</p>`,
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/frontend/success_icon.svg'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  allowOutsideClick: false,
                  confirmButtonText: 'Ok, got it 知道了',
                  customClass: {
                    confirmButton: 'btn p4a__success-swal-btn',
                  },
                  buttonsStyling: false,
                })
                  .then(result => {
                    if (result.value) {
                      this.$router.push({ name: 'appointments-front-end' })
                      document.body.style.paddingTop = '0px'
                    }
                  })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: response.data.message || '',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'customerName') {
                    this.customerNameError = validationError.msg
                    this.customerNameValidation = true
                    this.$root.$emit('bv::hide::modal', 'modal-3', '')
                    this.enableNextPhaseCustomer = false
                    this.phase = 'customerDetail'
                  } else if (validationError.param === 'customerContact') {
                    this.customerContactError = validationError.msg
                    this.customerContactValidation = true
                    this.$root.$emit('bv::hide::modal', 'modal-3', '')
                    this.enableNextPhaseCustomer = false
                    this.phase = 'customerDetail'
                  } else if (validationError.param === 'customerEmail') {
                    this.customerEmailError = validationError.msg
                    this.customerEmailValidation = true
                    this.$root.$emit('bv::hide::modal', 'modal-3', '')
                    this.enableNextPhaseCustomer = false
                    this.phase = 'customerDetail'
                  } else if (validationError.param === 'startDate') {
                    this.startError = validationError.msg
                    this.startValidation = true
                    this.$root.$emit('bv::hide::modal', 'modal-3', '')
                    this.enableNextPhaseCustomer = false
                    this.phase = 'customerDetail'
                  } else if (validationError.param === 'startTime') {
                    this.startTimeError = validationError.msg
                    this.startTimeValidation = true
                    this.$root.$emit('bv::hide::modal', 'modal-3', '')
                    this.enableNextPhaseCustomer = false
                    this.phase = 'customerDetail'
                  } else if (validationError.param === 'enteredOTP') {
                    this.enteredOTPError = validationError.msg
                    this.enteredOTPValidation = true
                  }
                })

                const items = document.getElementsByClassName('text-danger')
                window.scrollTo({
                  top: items[0].offsetTop,
                  behavior: 'smooth',
                })
              } else {
                this.enteredOTPError = error.data.message
                this.enteredOTPValidation = true
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .btn-group-toggle [class*=btn-outline-]:not(:last-child) {
    border-right-width: 1px !important;
  }
  .inlineElement {
    display: flex;
  }
  .clickableText {
    cursor: pointer;
    color: #104D9D;
  }
  .frontend{
    .page-content{
        background: #F5F0DF !important;
        background-size: 100% auto;
        .activities{
           &:before{
             background: unset;
           }
           &:after{
             background: unset;
           }
        }
    }
 }

  // Static design styles for Service Description Items / payment (P4A-XXX)
  .sr__offering-row {
    padding: 10px 0;
    border-bottom: 1px solid #EDE6D3;
    align-items: center;
  }
  .sr__qty-stepper {
    gap: 10px;
  }
  .sr__qty-btn {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid #D9CFAE;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  .sr__qty-value {
    min-width: 20px;
    text-align: center;
  }
  .sr__chip-btn {
    display: inline-flex;
    align-items: center;
    border: 1px solid #D9CFAE;
    background: #fff;
    border-radius: 6px;
    padding: 8px 14px;
    margin: 0 10px 10px 0;
    &--active {
      border-color: #A88B3F;
      background: #A88B3F;
      color: #fff;
    }
  }
  .p4a__order-items-block {
    padding: 10px 16px 0;
  }
  .sr__order-item-row {
    padding: 8px 0;
    border-bottom: 1px solid #EDE6D3;
  }
  .sr__item-price {
    white-space: nowrap;
    padding-left: 10px;
  }
  .sr__link-btn {
    position: static;
    display: inline-block;
    width: auto;
    padding: 0 !important;
    background: none !important;
    color: rgba(159, 144, 96, 1) !important;
    text-decoration: underline;
    font-size: 13px;
  }
  .sr__qty-badge {
    min-width: 28px;
    height: 24px;
    padding: 0 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #D9CFAE;
    border-radius: 4px;
    background: #fff;
  }
  .p4a__common-btn-outline {
    border: 1px solid #A88B3F;
    background: #fff;
    color: #A88B3F;
    padding: 10px;
    border-radius: 6px;
    &:disabled {
      opacity: 0.5;
    }
  }
</style>
